export const RESPONSES: Record<string, string> = {
  "01-market-data/ETFs/exposure": `[
  {
    "ticker": "XLK",
    "fundName": "Technology Select Sector SPDR Fund",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "24.17%",
    "marketValue": "$10.46B",
    "rawAllocation": 0.2417,
    "rawMarketValue": 10460000000
  },
  {
    "ticker": "FTEC",
    "fundName": "Fidelity MSCI Information Technology Index ETF",
    "segment": "Equity: U.S. Information Technology",
    "allocation": "23.75%",
    "marketValue": "$1.45B",
    "rawAllocation": 0.2375,
    "rawMarketValue": 1450000000
  },
  {
    "ticker": "IXN",
    "fundName": "iShares Global Tech ETF",
    "segment": "Equity: Global Information Technology",
    "allocation": "23.39%",
    "marketValue": "$737.66M",
    "rawAllocation": 0.2339,
    "rawMarketValue": 737660000
  }
]`,
  "01-market-data/ETFs/fund-details": `{
  "ticker": "SPY",
  "fund": "SPDR S&P 500 ETF Trust",
  "assetclass": "Equity",
  "category": "Size and Style",
  "focus": "Large Cap",
  "niche": "Broad-based",
  "region": "North America",
  "geography": "U.S.",
  "segment": "Equity: U.S.  -  Large Cap",
  "segmentid": 261,
  "hassegmentreport": true,
  "lettergrade": "A",
  "analystpick": false,
  "opportunitieslist": false,
  "efficiencyscore": 99.69286,
  "tradabilityscore": 99.679609,
  "fitscore": null,
  "segmentavgefficiency": 80.6980909027027,
  "segmentavgtradability": 79.1212271516854,
  "segmentavgfit": 59.8830314558824,
  "overallratingdate": "2024-08-15T00:00:00.000Z",
  "msciesghasbadge": false,
  "genericrpt": false,
  "msciesgready": true,
  "dividendyield": null,
  "state": 1,
  "inverse": false,
  "leveraged": false,
  "overallratingscore": "A ",
  "morecomparisons": "IVV,VOO,SPLG,SCHX,IWB",
  "medianspreadpct45day": 0.000029,
  "primaryexchange": "NYSEArca"
}`,
  "01-market-data/ETFs/holdings": `[
  {
    "ticker": "NVDA",
    "name": "NVIDIA Corporation",
    "weight": "7.17%",
    "shares": 305156465,
    "marketValue": 44519276678.85,
    "rawWeight": 0.0716544211188534
  },
  {
    "ticker": "AAPL",
    "name": "Apple Inc.",
    "weight": "6.95%",
    "shares": 188603226,
    "marketValue": 43190138754,
    "rawWeight": 0.0695151543630329
  },
  {
    "ticker": "MSFT",
    "name": "Microsoft Corporation",
    "weight": "6.17%",
    "shares": 92204348,
    "marketValue": 38309984550.52,
    "rawWeight": 0.0616604754349895
  }
]`,
  "01-market-data/ETFs/holdings-all": `[
  {
    "name": "NVIDIA Corporation",
    "ticker": "NVDA",
    "weight": "7.17%",
    "rawWeight": 0.0716544211188534,
    "since": "2024-03-15"
  },
  {
    "name": "Apple Inc.",
    "ticker": "AAPL",
    "weight": "6.95%",
    "rawWeight": 0.0695151543630329,
    "since": "2024-03-15"
  },
  {
    "name": "Microsoft Corporation",
    "ticker": "MSFT",
    "weight": "6.17%",
    "rawWeight": 0.0616604754349895,
    "since": "2024-03-15"
  }
]`,
  "01-market-data/ETFs/weights": `{
  "sector": [
    {
      "name": "Technology Services",
      "weight": "21.08%",
      "rawWeight": 0.21079285342758
    },
    {
      "name": "Commercial Services",
      "weight": "2.90%",
      "rawWeight": 0.0289666913939312
    }
  ],
  "regions": [
    {
      "name": "United States",
      "weight": "100.00%",
      "benchmarkWeight": "99.89%",
      "rawWeight": 1
    },
    {
      "name": "Canada",
      "weight": "--",
      "benchmarkWeight": "0.11%",
      "rawWeight": "--"
    }
  ]
}`,
  "01-market-data/ETFs/find-tickers": `[
  {
    "id": 23,
    "name": "Aptus International Enhanced Yield",
    "ticker": "IDUB",
    "symbol": "CBOE:IDUB",
    "exchange": "CBOE",
    "market": "america",
    "type": "etf fund"
  },
  {
    "id": 6,
    "name": "ProShares Ultra MSCI Brazil Capped",
    "ticker": "UBR",
    "symbol": "AMEX:UBR",
    "exchange": "AMEX",
    "market": "america",
    "type": "etf fund"
  },
  {
    "id": 20,
    "name": "Amplify CWP Enhanced Dividend Income ETF",
    "ticker": "DIVO",
    "symbol": "AMEX:DIVO",
    "exchange": "AMEX",
    "market": "america",
    "type": "etf fund"
  },
  {
    "id": 3,
    "name": "Thornburg Core Plus Bond ETF",
    "ticker": "TPLS",
    "symbol": "NASDAQ:TPLS",
    "exchange": "NASDAQ",
    "market": "america",
    "type": "etf fund"
  },
  {
    "id": 2,
    "name": "United States Gasoline Fund LP",
    "ticker": "UGA",
    "symbol": "AMEX:UGA",
    "exchange": "AMEX",
    "market": "america",
    "type": "etf fund"
  }
]`,
  "01-market-data/ETFs/historical-prices": `[
  {
    "time": "2025-12-19T19:03:05.000Z",
    "ticker": "SPY",
    "open": "500.1200",
    "high": "502.5600",
    "low": "499.7800",
    "close": "501.3400",
    "volume": "45000000"
  },
  {
    "time": "2025-12-18T14:30:00.000Z",
    "ticker": "SPY",
    "open": "498.4500",
    "high": "501.2300",
    "low": "497.8000",
    "close": "500.1000",
    "volume": "42000000"
  }
]`,
  "01-market-data/ETFs/ticker-details": `{
  "id": 5512,
  "name": "Invesco QQQ Trust Series I",
  "ticker": "QQQ",
  "symbol": "NASDAQ:QQQ",
  "exchange": "NASDAQ",
  "market": "america",
  "country": "United States",
  "type": "etf fund",
  "sector": "Miscellaneous",
  "industry": "Investment Trusts/Mutual Funds",
  "currency": "USD",
  "lastClose": 717,
  "changePct": -1.17296931198755,
  "issuer": "Invesco",
  "description": "To maintain the correspondence between the composition and weights of the securities in the trust (the \"securities\") and the stocks in the NASDAQ-100 Index\u00ae, the adviser adjusts the securities from time to time to conform to periodic changes in the identity and/or relative weights of index securities. The composition and weighting of the securities portion of a portfolio deposit are also adjusted to conform to changes in the index.",
  "inception": "1999-03-10T00:00:00.000Z"
}`,
  "01-market-data/ETFs/quote": `{
  "latestClose": 717,
  "latestOpen": 717.7199707,
  "latestHigh": 718.73999023,
  "latestLow": 712.55999756,
  "previousClose": 725.51000977,
  "week52Range": {
    "high": 748.65,
    "low": 551.56
  },
  "week52AvgClose": 622.6539,
  "ema30": 715.807,
  "ema60": 695.0426,
  "ema90": 677.9436,
  "ema120": 664.6458,
  "ytdClosePctChange": 16.9429,
  "volume": 15379091,
  "avgVolumeLifetime": 64776883.168,
  "nav": 723.16,
  "expense": 0.0018
}`,
  "01-market-data/ETFs/gainers": `[
  {
    "ticker": "SPY",
    "pctchange": 1.234
  },
  {
    "ticker": "QQQ",
    "pctchange": 0.987
  },
  {
    "ticker": "IVV",
    "pctchange": 0.876
  }
]`,
  "01-market-data/ETFs/losers": `[
  {
    "ticker": "XLE",
    "pctchange": -2.345
  },
  {
    "ticker": "XLF",
    "pctchange": -1.234
  },
  {
    "ticker": "XLV",
    "pctchange": -0.987
  }
]`,
  "01-market-data/crypto/find-tickers": `[
  {
    "id": 1,
    "ticker": "BTC",
    "name": "Bitcoin",
    "type": "spot",
    "category": "cryptocurrencies"
  },
  {
    "id": 2,
    "ticker": "ETH",
    "name": "Ethereum",
    "type": "spot",
    "category": "smart contract platforms"
  },
  {
    "id": 3,
    "ticker": "USDT",
    "name": "Tether USDt",
    "type": "spot",
    "category": "stablecoins"
  },
  {
    "id": 4,
    "ticker": "BNB",
    "name": "BNB",
    "type": "spot",
    "category": "smart contract platforms"
  },
  {
    "id": 5,
    "ticker": "USDC",
    "name": "USDC",
    "type": "spot",
    "category": "stablecoins"
  }
]`,
  "01-market-data/crypto/historical-prices": `[
  {
    "time": "2025-12-19T12:43:00.000Z",
    "ticker": "BTC",
    "open": "85463.3000",
    "high": "88292.5500",
    "low": "85134.0600",
    "close": "87981.6800",
    "volume": "59129171968"
  },
  {
    "time": "2025-12-18T00:00:00.000Z",
    "ticker": "BTC",
    "open": "86144.3700",
    "high": "89412.6600",
    "low": "84436.3100",
    "close": "85462.5100",
    "volume": "52667115348"
  }
]`,
  "01-market-data/crypto/ticker-details": `{
  "id": 1,
  "ticker": "BTC",
  "name": "Bitcoin",
  "type": "spot",
  "category": "cryptocurrencies",
  "rating": "strongsell",
  "cap": "1248599187015.109900",
  "supply": "20046943.000000",
  "lastClose": 62283.98828125,
  "changePct": -2.60838509580443
}`,
  "01-market-data/crypto/quote": `{
  "latestClose": 87981.68,
  "latestOpen": 85463.3,
  "latestHigh": 88292.55,
  "latestLow": 85134.06,
  "previousClose": 85462.51,
  "week52Range": {
    "high": 108268.45,
    "low": 38420.12
  },
  "week52AvgClose": 72500.34,
  "ema30": 88234.56,
  "ema60": 85432.78,
  "ema90": 82123.45,
  "ema120": 79876.23,
  "ytdClosePctChange": 65.432,
  "volume": 59129171968,
  "avgVolumeLifetime": 42000000000
}`,
  "01-market-data/crypto/gainers": `[
  {
    "ticker": "VANA",
    "pctchange": 24077102.262329
  },
  {
    "ticker": "LUNA",
    "pctchange": 29965.2941892873
  },
  {
    "ticker": "SPACE",
    "pctchange": 27397.3324788449
  }
]`,
  "01-market-data/crypto/losers": `[
  {
    "ticker": "ZYPTO",
    "pctchange": -100
  },
  {
    "ticker": "3ULL",
    "pctchange": -82.1428578389002
  },
  {
    "ticker": "ARCA",
    "pctchange": -82.0354057891293
  }
]`,
  "01-market-data/forex/find-tickers": `[
  {
    "id": 2,
    "ticker": "AEDBRX",
    "detail": "U.A.E. DIRHAM / BRAZILIAN REAL REFERENCE RATE",
    "exchange": "IDC",
    "country": "AE"
  },
  {
    "id": 3,
    "ticker": "AEDCAD",
    "detail": "U.A.E. DIRHAM / CANADIAN DOLLAR",
    "exchange": "IDC",
    "country": "AE"
  },
  {
    "id": 4,
    "ticker": "AEDCHF",
    "detail": "U.A.E. DIRHAM / SWISS FRANC",
    "exchange": "IDC",
    "country": "AE"
  },
  {
    "id": 5,
    "ticker": "AEDEUR",
    "detail": "U.A.E. DIRHAM / EURO",
    "exchange": "IDC",
    "country": "AE"
  },
  {
    "id": 7,
    "ticker": "AEDHKD",
    "detail": "U.A.E. DIRHAM / HONG KONG DOLLAR",
    "exchange": "IDC",
    "country": "AE"
  },
  {
    "id": 8,
    "ticker": "AEDINR",
    "detail": "U.A.E. DIRHAM / INDIAN RUPEE",
    "exchange": "IDC",
    "country": "AE"
  }
]`,
  "01-market-data/forex/historical-prices": `[
  {
    "time": "2025-12-19T13:26:59.000Z",
    "ticker": "AEDAUD",
    "open": "0.4100",
    "high": "0.4100",
    "low": "0.4100",
    "close": "0.4100",
    "volume": "0"
  },
  {
    "time": "2025-12-18T00:00:00.000Z",
    "ticker": "AEDAUD",
    "open": "0.4100",
    "high": "0.4100",
    "low": "0.4100",
    "close": "0.4100",
    "volume": "0"
  }
]`,
  "01-market-data/forex/ticker-details": `{
  "id": 27,
  "ticker": "AEDUSD",
  "detail": "U.A.E. DIRHAM / U.S. DOLLAR",
  "exchange": "IDC",
  "country": "AE",
  "rating": "strongsell",
  "lastClose": 0.2722718418,
  "changePct": -0.0353971137185937
}`,
  "01-market-data/forex/quote": `{
  "latestClose": 1.1045,
  "latestOpen": 1.1032,
  "latestHigh": 1.1067,
  "latestLow": 1.1021,
  "previousClose": 1.1032,
  "week52Range": {
    "high": 1.1278,
    "low": 1.0543
  },
  "week52AvgClose": 1.0891,
  "ema30": 1.1056,
  "ema60": 1.0998,
  "ema90": 1.0945,
  "ema120": 1.0912,
  "ytdClosePctChange": 1.234,
  "volume": 0,
  "avgVolumeLifetime": 0
}`,
  "01-market-data/forex/gainers": `[
  {
    "ticker": "USDBRL",
    "pctchange": 3.456
  },
  {
    "ticker": "EURUSD",
    "pctchange": 1.234
  },
  {
    "ticker": "GBPUSD",
    "pctchange": 0.987
  }
]`,
  "01-market-data/forex/losers": `[
  {
    "ticker": "USDJPY",
    "pctchange": -2.345
  },
  {
    "ticker": "AUDUSD",
    "pctchange": -1.678
  },
  {
    "ticker": "USDCHF",
    "pctchange": -0.987
  }
]`,
  "01-market-data/futures/find-tickers": `[
  {
    "id": 12,
    "ticker": "ESG",
    "name": "E-mini S&P 500 ESG Index Future",
    "exchange": "CME"
  },
  {
    "id": 50,
    "ticker": "BTC",
    "name": "Bitcoin Futures",
    "exchange": "CME"
  },
  {
    "id": 53,
    "ticker": "6N",
    "name": "New Zealand Dollar Futures",
    "exchange": "CME"
  },
  {
    "id": 6,
    "ticker": "HUF",
    "name": "Hungarian Forint Futures",
    "exchange": "CME"
  },
  {
    "id": 54,
    "ticker": "6S",
    "name": "Swiss Franc Futures",
    "exchange": "CME"
  },
  {
    "id": 55,
    "ticker": "ESR",
    "name": "EURO SHORT-TERM RATE (ESTR) FUT",
    "exchange": "CME"
  },
  {
    "id": 9,
    "ticker": "QG",
    "name": "E-mini Natural Gas Futures",
    "exchange": "NYM"
  }
]`,
  "01-market-data/futures/historical-prices": `[
  {
    "time": "2025-12-19T16:02:30.000Z",
    "ticker": "ALI",
    "open": "2920.2500",
    "high": "2965.2500",
    "low": "2914.0000",
    "close": "2964.0000",
    "volume": "327"
  },
  {
    "time": "2025-12-18T05:00:00.000Z",
    "ticker": "ALI",
    "open": "2823.7500",
    "high": "2823.7500",
    "low": "2823.7500",
    "close": "2823.7500",
    "volume": "0"
  }
]`,
  "01-market-data/futures/ticker-details": `{
  "id": 3,
  "ticker": "ALI",
  "name": "Aluminum Futures",
  "exchange": "CMX",
  "currency": "USD",
  "country": "america",
  "timezone": "EDT",
  "list": "2014-05-06T04:00:00.000Z",
  "expiration": "2026-09-28T00:00:00.000Z",
  "lastClose": 3399,
  "changePct": -11.9601113773231
}`,
  "01-market-data/futures/quote": `{
  "latestClose": 2964.0,
  "latestOpen": 2920.25,
  "latestHigh": 2965.25,
  "latestLow": 2914.0,
  "previousClose": 2823.75,
  "week52Range": {
    "high": 3200.0,
    "low": 2500.0
  },
  "week52AvgClose": 2850.5,
  "ema30": 2950.75,
  "ema60": 2900.25,
  "ema90": 2850.0,
  "ema120": 2800.5,
  "ytdClosePctChange": 5.678,
  "volume": 327,
  "avgVolumeLifetime": 500
}`,
  "01-market-data/futures/gainers": `[
  {
    "ticker": "ALI",
    "pctchange": 4.567
  },
  {
    "ticker": "M6A",
    "pctchange": 3.456
  },
  {
    "ticker": "BTC",
    "pctchange": 2.345
  }
]`,
  "01-market-data/futures/losers": `[
  {
    "ticker": "CL",
    "pctchange": -5.678
  },
  {
    "ticker": "NG",
    "pctchange": -4.567
  },
  {
    "ticker": "ES",
    "pctchange": -3.456
  }
]`,
  "01-market-data/indices/find-tickers": `[
  {
    "id": 75,
    "ticker": "AMZIVWAP",
    "name": "Alerian MLP Infrastructure Inde",
    "exchange": "NYS"
  },
  {
    "id": 79,
    "ticker": "AOR-IV",
    "name": "ISHARES CORE 60/40 BALANCED ALL",
    "exchange": "ASE"
  },
  {
    "id": 5,
    "ticker": "AXJO",
    "name": "S&P/ASX 200",
    "exchange": "ASX"
  },
  {
    "id": 6,
    "ticker": "ATX",
    "name": "ATX",
    "exchange": "VIE"
  },
  {
    "id": 8,
    "ticker": "ERAEMEUT",
    "name": "Enhanced RAFI Emerging Markets",
    "exchange": "SNP"
  },
  {
    "id": 9,
    "ticker": "E2HCR",
    "name": "Dow Jones Europe ex-U.K. Health",
    "exchange": "DJI"
  },
  {
    "id": 12,
    "ticker": "FCHI",
    "name": "CAC 40",
    "exchange": "PAR"
  }
]`,
  "01-market-data/indices/historical-prices": `[
  {
    "time": "2025-12-19T16:31:46.000Z",
    "ticker": "GVZ",
    "open": "21.2600",
    "high": "21.3900",
    "low": "20.8100",
    "close": "21.0600",
    "volume": "0"
  },
  {
    "time": "2025-12-18T14:30:00.000Z",
    "ticker": "GVZ",
    "open": "20.6500",
    "high": "21.5100",
    "low": "20.0500",
    "close": "21.3100",
    "volume": "0"
  }
]`,
  "01-market-data/indices/ticker-details": `{
  "id": 5,
  "ticker": "AXJO",
  "name": "S&P/ASX 200",
  "exchange": "ASX",
  "country": "australia",
  "timezone": "AEST",
  "lastClose": 8816.09960938,
  "changePct": -0.142723001701814
}`,
  "01-market-data/indices/quote": `{
  "latestClose": 5890.25,
  "latestOpen": 5875.5,
  "latestHigh": 5902.34,
  "latestLow": 5868.12,
  "previousClose": 5875.5,
  "week52Range": {
    "high": 6240.78,
    "low": 5210.45
  },
  "week52AvgClose": 5720.34,
  "ema30": 5905.67,
  "ema60": 5850.23,
  "ema90": 5800.89,
  "ema120": 5750.45,
  "ytdClosePctChange": 8.234,
  "volume": 0,
  "avgVolumeLifetime": 0
}`,
  "01-market-data/indices/gainers": `[
  {
    "ticker": "SPX",
    "pctchange": 1.234
  },
  {
    "ticker": "NDX",
    "pctchange": 1.123
  },
  {
    "ticker": "DJI",
    "pctchange": 0.987
  }
]`,
  "01-market-data/indices/losers": `[
  {
    "ticker": "VIX",
    "pctchange": -12.345
  },
  {
    "ticker": "RUT",
    "pctchange": -2.345
  },
  {
    "ticker": "GVZ",
    "pctchange": -1.234
  }
]`,
  "01-market-data/indices/components": `{
  "symbol": "SPX",
  "components": [
    "AAPL",
    "MSFT",
    "GOOGL",
    "AMZN",
    "NVDA",
    "META",
    "TSLA",
    "BRK.B",
    "JPM",
    "V",
    "JNJ",
    "WMT",
    "MA",
    "PG",
    "UNH",
    "HD",
    "DIS",
    "BAC",
    "NFLX",
    "ADBE"
  ]
}`,
  "01-market-data/indices/exposure": `[
  {
    "symbol": "SPX",
    "components": [
      "AAPL",
      "MSFT",
      "GOOGL",
      "AMZN",
      "NVDA",
      "META",
      "TSLA",
      "BRK.B",
      "JPM",
      "V",
      "JNJ",
      "WMT",
      "MA",
      "PG",
      "UNH",
      "HD",
      "DIS",
      "BAC",
      "NFLX",
      "ADBE"
    ]
  },
  {
    "symbol": "NDX",
    "components": [
      "AAPL",
      "MSFT",
      "GOOGL",
      "AMZN",
      "NVDA",
      "META",
      "TSLA",
      "NFLX",
      "ADBE",
      "INTC"
    ]
  }
]`,
  "01-market-data/stocks/find-tickers": `[
  {
    "id": 10,
    "name": "Zoompass Holdings, Inc.",
    "ticker": "ZPAS",
    "symbol": "OTC:ZPAS",
    "exchange": "OTC",
    "market": "america",
    "type": "common stock"
  },
  {
    "id": 11,
    "name": "Roper Technologies, Inc.",
    "ticker": "ROP",
    "symbol": "NASDAQ:ROP",
    "exchange": "NASDAQ",
    "market": "america",
    "type": "common stock"
  },
  {
    "id": 4,
    "name": "JFB Construction Holdings Class A",
    "ticker": "JFB",
    "symbol": "NASDAQ:JFB",
    "exchange": "NASDAQ",
    "market": "america",
    "type": "common stock"
  },
  {
    "id": 22,
    "name": "Strive, Inc. Perf Pfd Registered Shs Series A",
    "ticker": "SATA",
    "symbol": "NASDAQ:SATA",
    "exchange": "NASDAQ",
    "market": "america",
    "type": "preferred stock"
  },
  {
    "id": 24,
    "name": "Minth Group Limited Unsponsored ADR",
    "ticker": "MNTHY",
    "symbol": "OTC:MNTHY",
    "exchange": "OTC",
    "market": "america",
    "type": "dr"
  }
]`,
  "01-market-data/stocks/historical-prices": `[
  {
    "time": "2025-12-19T19:03:05.000Z",
    "ticker": "AAPL",
    "open": "272.1400",
    "high": "272.9200",
    "low": "270.2700",
    "close": "270.6700",
    "volume": "43267805"
  },
  {
    "time": "2025-12-18T14:30:00.000Z",
    "ticker": "AAPL",
    "open": "273.6100",
    "high": "273.6300",
    "low": "266.9500",
    "close": "272.1900",
    "volume": "51600000"
  }
]`,
  "01-market-data/stocks/ticker-details": `{
  "id": 17640,
  "name": "Apple Inc.",
  "ticker": "AAPL",
  "symbol": "NASDAQ:AAPL",
  "exchange": "NASDAQ",
  "market": "america",
  "country": "United States",
  "type": "common stock",
  "sector": "Electronic Technology",
  "industry": "Telecommunications Equipment",
  "currency": "USD",
  "lastClose": 297.78500366,
  "changePct": 0.260931909533994
}`,
  "01-market-data/stocks/quote": `{
  "latestClose": 150.25,
  "latestOpen": 151.1,
  "latestHigh": 152.34,
  "latestLow": 149.87,
  "previousClose": 149.45,
  "week52Range": {
    "high": 180.12,
    "low": 120.34
  },
  "week52AvgClose": 150.05,
  "ema30": 152.12,
  "ema60": 148.34,
  "ema90": 145.56,
  "ema120": 142.78,
  "ytdClosePctChange": 2.345,
  "volume": 50000000,
  "avgVolumeLifetime": 45000000
}`,
  "01-market-data/stocks/gainers": `[
  {
    "ticker": "AAPL",
    "pctchange": 2.345
  },
  {
    "ticker": "MSFT",
    "pctchange": 1.234
  },
  {
    "ticker": "GOOGL",
    "pctchange": 0.987
  }
]`,
  "01-market-data/stocks/losers": `[
  {
    "ticker": "TSLA",
    "pctchange": -3.456
  },
  {
    "ticker": "META",
    "pctchange": -2.345
  },
  {
    "ticker": "NFLX",
    "pctchange": -1.234
  }
]`,
  "02-alternative-data/ESG": `[
  {
    "category": "esg",
    "score": 42.86,
    "grade": "BB",
    "id": "1"
  },
  {
    "category": "social",
    "score": 40,
    "grade": "BB",
    "id": "5"
  },
  {
    "category": "governance",
    "score": 31,
    "grade": "BB",
    "id": "6"
  },
  {
    "category": "controversy",
    "score": 20,
    "grade": "B",
    "id": "3"
  },
  {
    "category": "environment",
    "score": 57,
    "grade": "BBB",
    "id": "4"
  }
]`,
  "02-alternative-data/sentiment/analysts": `{
  "sentiment": "NEGATIVE",
  "score": 0.31
}`,
  "02-alternative-data/sentiment/journalists": `{
  "label": "NEGATIVE",
  "score": 0.982357367873192,
  "breakdown": {
    "positive": {
      "count": 231,
      "avgScore": 0.903340172767639
    },
    "negative": {
      "count": 1292,
      "avgScore": 0.982357367873192
    }
  }
}`,
  "02-alternative-data/sentiment/social-media": `{
  "label": "NEGATIVE",
  "score": 0.99506558974584,
  "breakdown": {
    "positive": {
      "count": 145,
      "avgScore": 0.93158021569252
    },
    "negative": {
      "count": 436,
      "avgScore": 0.99506558974584
    }
  }
}`,
  "02-alternative-data/supply-chain/customers": `[
  {
    "ticker": "AMZN",
    "companyName": "Amazon com Inc",
    "marketCap": "2,522,766.91",
    "revenues": "742,776.00",
    "income": "90,798.00",
    "employees": "1,576,000"
  },
  {
    "ticker": "ALRM",
    "companyName": "Alarm com Holdings Inc",
    "marketCap": "2,609.99",
    "revenues": "1,037.56",
    "income": "127.30",
    "employees": "2,058"
  },
  {
    "ticker": "CXM",
    "companyName": "Sprinklr Inc",
    "marketCap": "1,257.01",
    "revenues": "810.48",
    "income": "127.36",
    "employees": "3,258"
  },
  {
    "ticker": "EVBG",
    "companyName": "Everbridge Inc",
    "marketCap": "1,446.57",
    "revenues": "451.02",
    "income": "-52.73",
    "employees": "804"
  },
  {
    "ticker": "EVCM",
    "companyName": "Evercommerce Inc",
    "marketCap": "1,679.67",
    "revenues": "560.11",
    "income": "33.93",
    "employees": "1,800"
  },
  {
    "ticker": "INFY",
    "companyName": "Infosys Limited",
    "marketCap": "44,620.77",
    "revenues": "20,158.00",
    "income": "3,316.00",
    "employees": "346,845"
  },
  {
    "ticker": "KD",
    "companyName": "Kyndryl Holdings Inc",
    "marketCap": "2,632.24",
    "revenues": "15,092.00",
    "income": "198.00",
    "employees": "80,000"
  },
  {
    "ticker": "RSKIA",
    "companyName": "George Risk Industries Inc",
    "marketCap": "93.29",
    "revenues": "27.96",
    "income": "8.35",
    "employees": "200"
  },
  {
    "ticker": "SEM",
    "companyName": "Select Medical Holdings Corp",
    "marketCap": "2,079.08",
    "revenues": "5,521.13",
    "income": "203.58",
    "employees": "45,300"
  },
  {
    "ticker": "SNPO",
    "companyName": "Snap One Holdings Corp",
    "marketCap": "820.87",
    "revenues": "1,055.02",
    "income": "-17.85",
    "employees": "1,610"
  },
  {
    "ticker": "SPT",
    "companyName": "Sprout Social Inc",
    "marketCap": "442.05",
    "revenues": "468.91",
    "income": "-38.44",
    "employees": "1,362"
  },
  {
    "ticker": "ANGI",
    "companyName": "Angi Inc",
    "marketCap": "240.80",
    "revenues": "1,021.66",
    "income": "19.75",
    "employees": "2,300"
  },
  {
    "ticker": "BMBL",
    "companyName": "Bumble Inc",
    "marketCap": "410.22",
    "revenues": "930.94",
    "income": "-862.55",
    "employees": "580"
  },
  {
    "ticker": "DT",
    "companyName": "Dynatrace Inc",
    "marketCap": "13,043.64",
    "revenues": "1,941.65",
    "income": "-159.78",
    "employees": "4,700"
  }
]`,
  "02-alternative-data/supply-chain/peers": `[
  {
    "name": "GainClients, Inc.",
    "ticker": "GCLT",
    "symbol": "OTC:GCLT"
  },
  {
    "name": "Brag House Holdings, Inc.",
    "ticker": "TBH",
    "symbol": "NASDAQ:TBH"
  },
  {
    "name": "Grayscale Stacks Trust",
    "ticker": "STCK",
    "symbol": "OTC:STCK"
  },
  {
    "name": "Winners, Inc.",
    "ticker": "WNRS",
    "symbol": "OTC:WNRS"
  },
  {
    "name": "Zeta Network Group Class A",
    "ticker": "ZNB",
    "symbol": "NASDAQ:ZNB"
  },
  {
    "name": "Gartner, Inc.",
    "ticker": "IT",
    "symbol": "NYSE:IT"
  },
  {
    "name": "Hartford Creative Group Inc",
    "ticker": "HFUS",
    "symbol": "OTC:HFUS"
  },
  {
    "name": "Internetarray, Inc.",
    "ticker": "INAR",
    "symbol": "OTC:INAR"
  },
  {
    "name": "Liberty Media Corporation Series A Liberty Formula One",
    "ticker": "FWONA",
    "symbol": "NASDAQ:FWONA"
  },
  {
    "name": "Bollinger Innovations, Inc.",
    "ticker": "BINI",
    "symbol": "OTC:BINI"
  },
  {
    "name": "Nextdoor Holdings, Inc. Class A",
    "ticker": "NXDR",
    "symbol": "NYSE:NXDR"
  },
  {
    "name": "FuboTV Inc. Class A",
    "ticker": "FUBO",
    "symbol": "NYSE:FUBO"
  }
]`,
  "02-alternative-data/supply-chain/suppliers": `[
  {
    "ticker": "GOOG",
    "companyName": "Alphabet Inc",
    "marketCap": "4,116,377.17",
    "revenues": "422,498.00",
    "income": "160,208.00",
    "employees": "46,224"
  },
  {
    "ticker": "AAOI",
    "companyName": "Applied Optoelectronics Inc",
    "marketCap": "10,176.32",
    "revenues": "506.29",
    "income": "-43.34",
    "employees": "4,691"
  },
  {
    "ticker": "AI",
    "companyName": "C3 ai Inc",
    "marketCap": "1,234.16",
    "revenues": "351.68",
    "income": "-381.34",
    "employees": "863"
  },
  {
    "ticker": "AKAM",
    "companyName": "Akamai Technologies Inc",
    "marketCap": "17,102.51",
    "revenues": "4,266.65",
    "income": "435.18",
    "employees": "11,000"
  },
  {
    "ticker": "AMBA",
    "companyName": "Ambarella Inc",
    "marketCap": "2,706.14",
    "revenues": "403.27",
    "income": "-93.96",
    "employees": "959"
  },
  {
    "ticker": "APP",
    "companyName": "Applovin Corporation",
    "marketCap": "161,343.47",
    "revenues": "6,124.93",
    "income": "4,104.94",
    "employees": "898"
  },
  {
    "ticker": "APPN",
    "companyName": "Appian Corporation",
    "marketCap": "1,621.83",
    "revenues": "762.60",
    "income": "0.89",
    "employees": "2,149"
  },
  {
    "ticker": "APPS",
    "companyName": "Digital Turbine Inc",
    "marketCap": "1,263.45",
    "revenues": "566.52",
    "income": "-37.73",
    "employees": "407"
  },
  {
    "ticker": "ASFT",
    "companyName": "Appsoft Technologies Inc",
    "marketCap": "1.35",
    "revenues": "0.00",
    "income": "-0.09",
    "employees": "0"
  },
  {
    "ticker": "AVPT",
    "companyName": "Avepoint Inc",
    "marketCap": "2,462.26",
    "revenues": "442.90",
    "income": "46.80",
    "employees": "333"
  },
  {
    "ticker": "BASE",
    "companyName": "Couchbase Inc",
    "marketCap": "1,340.87",
    "revenues": "191.08",
    "income": "-80.76",
    "employees": "792"
  },
  {
    "ticker": "BLZE",
    "companyName": "Backblaze Inc",
    "marketCap": "871.57",
    "revenues": "150.07",
    "income": "-22.44",
    "employees": "320"
  },
  {
    "ticker": "BRO",
    "companyName": "Brown and Brown Inc",
    "marketCap": "25,548.75",
    "revenues": "6,399.00",
    "income": "1,160.00",
    "employees": "22,888"
  },
  {
    "ticker": "CMBMF",
    "companyName": "Cambium Networks Corp",
    "marketCap": "9.80",
    "revenues": "169.21",
    "income": "-29.93",
    "employees": "0"
  },
  {
    "ticker": "CMCM",
    "companyName": "Cheetah Mobile Inc",
    "marketCap": "4,615.75",
    "revenues": "164.27",
    "income": "-33.63",
    "employees": "934"
  },
  {
    "ticker": "CXM",
    "companyName": "Sprinklr Inc",
    "marketCap": "1,257.01",
    "revenues": "810.48",
    "income": "127.36",
    "employees": "3,258"
  }
]`,
  "02-alternative-data/web-traffic": `{
  "traffic": {
    "visits": "719.42M",
    "change": "+2%",
    "pagesPerVisit": 3.23,
    "avgVisitDuration": "07:54",
    "bounceRate": "60.11%",
    "organicSearchTraffic": "856.67M",
    "organicSearchTrafficChange": null,
    "paidSearchTraffic": "9.6M",
    "paidSearchTrafficChange": "+32%",
    "globalRank": 44,
    "globalRankLocation": "Worldwide",
    "countryRank": 35,
    "countryRankLocation": "United States",
    "visitsInt": 719420000,
    "changeNum": 2,
    "bounceRateNum": 60.11,
    "organicSearchTrafficInt": 856670000,
    "paidSearchTrafficInt": 9600000,
    "paidSearchTrafficChangeNum": 32
  },
  "last3Months": [
    {
      "displayValue": "719.42M",
      "rawValue": 719420000
    },
    {
      "displayValue": "704.64M",
      "rawValue": 704640000
    },
    {
      "displayValue": "635.76M",
      "rawValue": 635760000
    }
  ],
  "trafficByCountry": [
    {
      "country": "United States",
      "trafficShare": "35.49%",
      "traffic": "255.33M",
      "desktopShare": "38.4%",
      "mobileShare": "61.6%",
      "trafficShareNum": 35.49,
      "trafficInt": 255330000,
      "desktopShareNum": 38.4,
      "mobileShareNum": 61.6
    },
    {
      "country": "United Kingdom",
      "trafficShare": "6.44%",
      "traffic": "46.3M",
      "desktopShare": "30.37%",
      "mobileShare": "69.63%",
      "trafficShareNum": 6.44,
      "trafficInt": 46300000,
      "desktopShareNum": 30.37,
      "mobileShareNum": 69.63
    },
    {
      "country": "India",
      "trafficShare": "6.19%",
      "traffic": "44.5M",
      "desktopShare": "23.99%",
      "mobileShare": "76.01%",
      "trafficShareNum": 6.19,
      "trafficInt": 44500000,
      "desktopShareNum": 23.99,
      "mobileShareNum": 76.01
    },
    {
      "country": "Japan",
      "trafficShare": "4.44%",
      "traffic": "31.94M",
      "desktopShare": "56.8%",
      "mobileShare": "43.2%",
      "trafficShareNum": 4.44,
      "trafficInt": 31940000,
      "desktopShareNum": 56.8,
      "mobileShareNum": 43.2
    },
    {
      "country": "Canada",
      "trafficShare": "3.51%",
      "traffic": "25.22M",
      "desktopShare": "48.58%",
      "mobileShare": "51.42%",
      "trafficShareNum": 3.51,
      "trafficInt": 25220000,
      "desktopShareNum": 48.58,
      "mobileShareNum": 51.42
    }
  ],
  "trafficJourney": {
    "sources": [
      {
        "name": "Direct",
        "share": "45.31%",
        "change": "+0.71%",
        "shareNum": 45.31,
        "changeNum": 0.71
      },
      {
        "name": "Google organic•google.com",
        "share": "28.52%",
        "change": "-2.28%",
        "shareNum": 28.52,
        "changeNum": -2.28
      },
      {
        "name": "Chatgpt.com",
        "share": "1.4%",
        "change": "-6.94%",
        "shareNum": 1.4,
        "changeNum": -6.94
      },
      {
        "name": "stripecdn.com",
        "share": "0.75%",
        "change": "+1,496.41%",
        "shareNum": 0.75,
        "changeNum": 1
      },
      {
        "name": "Bing.com",
        "share": "0.68%",
        "change": "-23.81%",
        "shareNum": 0.68,
        "changeNum": -23.81
      }
    ],
    "destinations": [
      {
        "name": "Google.com",
        "share": "7.23%",
        "change": "+5.03%",
        "shareNum": 7.23,
        "changeNum": 5.03
      },
      {
        "name": "Chatgpt.com",
        "share": "6.52%",
        "change": "-6.94%",
        "shareNum": 6.52,
        "changeNum": -6.94
      },
      {
        "name": "Microsoft.com",
        "share": "6.37%",
        "change": "-7.59%",
        "shareNum": 6.37,
        "changeNum": -7.59
      },
      {
        "name": "Youtube.com",
        "share": "3.24%",
        "change": "+13.11%",
        "shareNum": 3.24,
        "changeNum": 13.11
      },
      {
        "name": "Riotgames.com",
        "share": "3.15%",
        "change": "-4.9%",
        "shareNum": 3.15,
        "changeNum": -4.9
      }
    ]
  },
  "topKeywords": [
    {
      "keyword": "apple",
      "intent": "N",
      "position": 1,
      "volume": 4090000,
      "cpc": 0.2,
      "trafficPercent": "1.79%",
      "trafficPercentNum": 1.79
    },
    {
      "keyword": "iphone 17",
      "intent": "C, N",
      "position": 1,
      "volume": 3350000,
      "cpc": 1.84,
      "trafficPercent": "1.47%",
      "trafficPercentNum": 1.47
    },
    {
      "keyword": "facebook",
      "intent": "N",
      "position": 2,
      "volume": 101000000,
      "cpc": 6.67,
      "trafficPercent": "1.44%",
      "trafficPercentNum": 1.44
    },
    {
      "keyword": "apple tv",
      "intent": "N",
      "position": 1,
      "volume": 1830000,
      "cpc": 0.84,
      "trafficPercent": "0.8%",
      "trafficPercentNum": 0.8
    },
    {
      "keyword": "apple store",
      "intent": "N",
      "position": 1,
      "volume": 1500000,
      "cpc": 0.03,
      "trafficPercent": "0.66%",
      "trafficPercentNum": 0.66
    }
  ],
  "backlinks": {
    "authorityScore": 100,
    "referringDomains": "5.95M",
    "referringDomainsChange": "+1%",
    "backlinks": "6.5B",
    "backlinksChange": null,
    "referringDomainsInt": 5950000,
    "referringDomainsChangeNum": 1,
    "backlinksInt": 6500000000
  },
  "site": "apple.com",
  "date": "2026-07-12T12:47:56.904Z",
  "_id": "6a538cfc1cca1830ebcbd5cb"
}`,
  "03-fundamentals/corp.-intelligence/00-profile": `{
  "address1": "One Apple Park Way",
  "city": "Cupertino",
  "state": "CA",
  "zip": "95014",
  "country": "United States",
  "website": "https://www.apple.com",
  "industry": "Consumer Electronics",
  "sector": "Technology",
  "longBusinessSummary": "Apple Inc. designs, manufactures, and markets smartphones...",
  "fullTimeEmployees": 166000,
  "companyOfficers": [
    {
      "name": "Mr. Timothy D. Cook",
      "age": 63,
      "title": "CEO & Director",
      "totalPay": 16520856
    }
  ],
  "overallRisk": 1,
  "governanceEpochDate": "2025-12-01T00:00:00.000Z"
  "auditRisk": 7,
  "boardRisk": 1,
  "compensationRisk": 3,
  "shareHolderRightsRisk": 1,
  "compensationAsOfEpochDate": "2024-12-31T00:00:00.000Z",
  "irWebsite": "http://investor.apple.com/",
  "executiveTeam": [],
}`,
  "03-fundamentals/corp.-intelligence/01-snapshot": `{
  "previousClose": 271.84,
  "open": 273.605,
  "dayLow": 266.96,
  "dayHigh": 273.62,
  "volume": 51509672,
  "averageVolume": 46958041,
  "marketCap": 4039405731840,
  "trailingPE": 36.49,
  "forwardPE": 29.84,
  "dividendRate": 1.04,
  "dividendYield": 0.0038,
  "exDividendDate": "2025-11-10T00:00:00.000Z",
  "fiftyTwoWeekLow": 169.21,
  "fiftyTwoWeekHigh": 288.62,
  "beta": 1.107
}`,
  "03-fundamentals/corp.-intelligence/KPIs": `{
  "enterpriseValue": 4079655583744,
  "forwardPE": 29.84,
  "profitMargins": 0.269,
  "floatShares": 14750642146,
  "sharesOutstanding": 14776353000,
  "sharesShort": 129458559,
  "shortRatio": 2.64,
  "shortPercentOfFloat": 0.0088,
  "heldPercentInsiders": 0.01697,
  "heldPercentInstitutions": 0.64406,
  "beta": 1.107,
  "bookValue": 4.991,
  "priceToBook": 54.54,
  "lastSplitFactor": "4:1",
  "lastSplitDate": 1598832000
}`,
  "03-fundamentals/corp.-intelligence/analyst-ratings": `[
  {
    "period": "0m",
    "strongBuy": 5,
    "buy": 24,
    "hold": 15,
    "sell": 1,
    "strongSell": 3
  },
  {
    "period": "-1m",
    "strongBuy": 5,
    "buy": 24,
    "hold": 15,
    "sell": 1,
    "strongSell": 3
  },
  {
    "period": "-2m",
    "strongBuy": 5,
    "buy": 24,
    "hold": 15,
    "sell": 1,
    "strongSell": 3
  },
  {
    "period": "-3m",
    "strongBuy": 5,
    "buy": 23,
    "hold": 15,
    "sell": 1,
    "strongSell": 3
  }
]`,
  "03-fundamentals/corp.-intelligence/key-dates": `{
  "earnings": {
    "earningsDate": ["2026-01-29T21:00:00.000Z"],
    "earningsCallDate": ["2025-10-30T21:00:00.000Z"],
    "isEarningsDateEstimate": true,
    "earningsAverage": 2.6647,
    "earningsLow": 2.51,
    "earningsHigh": 2.76,
    "revenueAverage": 138253076640,
    "revenueLow": 136679500000,
    "revenueHigh": 142741000000
  },
  "exDividendDate": "2025-11-10T00:00:00.000Z",
  "dividendDate": "2025-11-13T00:00:00.000Z"
}`,
  "03-fundamentals/corp.-intelligence/operating-info": `{
  "address1": "One Apple Park Way",
  "city": "Cupertino",
  "state": "CA",
  "zip": "95014",
  "country": "United States",
  "phone": "(408) 996-1010",
  "website": "https://www.apple.com",
  "industry": "Consumer Electronics",
  "sector": "Technology",
  "longBusinessSummary": "Apple Inc. designs, manufactures, and markets smartphones, personal computers, tablets, wearables, and accessories worldwide...",
  "fullTimeEmployees": 166000
}`,
  "03-fundamentals/earnings/history": `[
  {
    "epsActual": 2.4,
    "epsEstimate": 2.34102,
    "epsDifference": 0.06,
    "surprisePercent": 0.0252,
    "quarter": "2024-12-31T00:00:00.000Z",
    "currency": "USD",
    "period": "-4q"
  },
  {
    "epsActual": 1.65,
    "epsEstimate": 1.62253,
    "epsDifference": 0.03,
    "surprisePercent": 0.016900001,
    "quarter": "2025-03-31T00:00:00.000Z",
    "currency": "USD",
    "period": "-3q"
  }
]`,
  "03-fundamentals/earnings/history-1": `[
  {
    "period": "0q",
    "endDate": "2025-12-31T00:00:00.000Z",
    "growth": 0.1103,
    "earningsEstimate": {
      "avg": 2.66574,
      "low": 2.51,
      "high": 2.8,
      "yearAgoEps": 2.4,
      "numberOfAnalysts": 29,
      "growth": 0.1107
    },
    "revenueEstimate": {
      "avg": 138253076640,
      "low": 136679500000,
      "high": 142741000000,
      "numberOfAnalysts": 29,
      "yearAgoRevenue": 124300000000,
      "growth": 0.1123
    },
    "epsTrend": {
      "current": 2.66574,
      "7daysAgo": 2.66367,
      "30daysAgo": 2.66153,
      "60daysAgo": 2.48232,
      "90daysAgo": 2.492
    },
    "epsRevisions": {
      "upLast7days": 1,
      "upLast30days": 1,
      "downLast30days": 0,
      "downLast7Days": 0
    }
  }
]`,
  "03-fundamentals/earnings/history-2": `{
  "symbol": "SP5",
  "estimates": [
    {
      "period": "0q",
      "growth": 0.1524
    },
    {
      "period": "+1q",
      "growth": 0.070300005
    },
    {
      "period": "0y",
      "growth": 0.109
    },
    {
      "period": "+1y",
      "growth": 0.1487
    },
    {
      "period": "LTG",
      "growth": 0.122
    }
  ]
}`,
  "03-fundamentals/earnings/history-3": `[
  {
    "dataframe": [
      {
        "label": "December 30, 2023",
        "values": [ "September 30, 2023" ]
      },
      {
        "label": "ASSETS:",
        "values": []
      },
      {
        "label": "Current assets:",
        "values": []
      },
      {
        "label": "Cash and cash equivalents",
        "values": [ "$", 40760, "$", 29965 ]
      },
      {
        "label": "Marketable securities",
        "values": [ 32340, 31590 ]
      },
      {
        "label": "Total current assets",
        "values": [ 143692, 143566 ]
      },
      {
        "label": "Total assets",
        "values": [ "$", 353514, "$", 352583 ]
      }
    ],
    "scale": 1000000000,
    "title": null,
    "statementType": "balance_sheet",
    "periods": [ "Period 1" ],
    "rawIndex": 5
  },
  {
    "dataframe": [
      {
        "label": "Three Months Ended",
        "values": []
      },
      {
        "label": "December 30, 2023",
        "values": [ "December 31, 2022" ]
      },
      {
        "label": "Cash generated by operating activities",
        "values": [ 39895, 34005 ]
      },
      {
        "label": "Cash generated by/(used in) investing activities",
        "values": [ 1927, -1445 ]
      },
      {
        "label": "Cash used in financing activities",
        "values": [ -30585, -35563 ]
      }
    ],
    "scale": 1000000000,
    "title": null,
    "statementType": "cash_flow",
    "periods": [],
    "rawIndex": 6
  }
]`,
  "03-fundamentals/earnings/report": `[
  {
    "epsActual": 2.4,
    "epsEstimate": 2.34102,
    "epsDifference": 0.06,
    "surprisePercent": 0.0252,
    "quarter": "2024-12-31T00:00:00.000Z",
    "currency": "USD",
    "period": "-4q"
  },
  {
    "epsActual": 1.65,
    "epsEstimate": 1.62253,
    "epsDifference": 0.03,
    "surprisePercent": 0.016900001,
    "quarter": "2025-03-31T00:00:00.000Z",
    "currency": "USD",
    "period": "-3q"
  }
]`,
  "03-fundamentals/earnings/report-1": `[
  {
    "period": "0q",
    "endDate": "2025-12-31T00:00:00.000Z",
    "growth": 0.1103,
    "earningsEstimate": {
      "avg": 2.66574,
      "low": 2.51,
      "high": 2.8,
      "yearAgoEps": 2.4,
      "numberOfAnalysts": 29,
      "growth": 0.1107
    },
    "revenueEstimate": {
      "avg": 138253076640,
      "low": 136679500000,
      "high": 142741000000,
      "numberOfAnalysts": 29,
      "yearAgoRevenue": 124300000000,
      "growth": 0.1123
    },
    "epsTrend": {
      "current": 2.66574,
      "7daysAgo": 2.66367,
      "30daysAgo": 2.66153,
      "60daysAgo": 2.48232,
      "90daysAgo": 2.492
    },
    "epsRevisions": {
      "upLast7days": 1,
      "upLast30days": 1,
      "downLast30days": 0,
      "downLast7Days": 0
    }
  }
]`,
  "03-fundamentals/earnings/report-2": `{
  "symbol": "SP5",
  "estimates": [
    {
      "period": "0q",
      "growth": 0.1524
    },
    {
      "period": "+1q",
      "growth": 0.070300005
    },
    {
      "period": "0y",
      "growth": 0.109
    },
    {
      "period": "+1y",
      "growth": 0.1487
    },
    {
      "period": "LTG",
      "growth": 0.122
    }
  ]
}`,
  "03-fundamentals/earnings/report-3": `[
  {
    "dataframe": [
      {
        "label": "December 30, 2023",
        "values": [ "September 30, 2023" ]
      },
      {
        "label": "ASSETS:",
        "values": []
      },
      {
        "label": "Current assets:",
        "values": []
      },
      {
        "label": "Cash and cash equivalents",
        "values": [ "$", 40760, "$", 29965 ]
      },
      {
        "label": "Marketable securities",
        "values": [ 32340, 31590 ]
      },
      {
        "label": "Total current assets",
        "values": [ 143692, 143566 ]
      },
      {
        "label": "Total assets",
        "values": [ "$", 353514, "$", 352583 ]
      }
    ],
    "scale": 1000000000,
    "title": null,
    "statementType": "balance_sheet",
    "periods": [ "Period 1" ],
    "rawIndex": 5
  },
  {
    "dataframe": [
      {
        "label": "Three Months Ended",
        "values": []
      },
      {
        "label": "December 30, 2023",
        "values": [ "December 31, 2022" ]
      },
      {
        "label": "Cash generated by operating activities",
        "values": [ 39895, 34005 ]
      },
      {
        "label": "Cash generated by/(used in) investing activities",
        "values": [ 1927, -1445 ]
      },
      {
        "label": "Cash used in financing activities",
        "values": [ -30585, -35563 ]
      }
    ],
    "scale": 1000000000,
    "title": null,
    "statementType": "cash_flow",
    "periods": [],
    "rawIndex": 6
  }
]`,
  "03-fundamentals/earnings/trend": `[
  {
    "epsActual": 2.4,
    "epsEstimate": 2.34102,
    "epsDifference": 0.06,
    "surprisePercent": 0.0252,
    "quarter": "2024-12-31T00:00:00.000Z",
    "currency": "USD",
    "period": "-4q"
  },
  {
    "epsActual": 1.65,
    "epsEstimate": 1.62253,
    "epsDifference": 0.03,
    "surprisePercent": 0.016900001,
    "quarter": "2025-03-31T00:00:00.000Z",
    "currency": "USD",
    "period": "-3q"
  }
]`,
  "03-fundamentals/earnings/transcript": `{
    "ticker": "AAPL",
    "year": "2024",
    "quarter": "2",
    "id": "eyJ0aWNrZXIiOiJBQVBMIiwieWVhciI6IjIwMjQiLCJxdWFydGVyIjoiMiJ9",
    "transcript": [
        {
            "paragraphNumber": 1,
            "speaker": "Suhasini Chandramouli",
            "content": "Good Afternoon, and welcome to the Apple Q2 Fiscal Year 2024 Earnings Conference Call. My name is Suhasini Chandramouli, Director of Investor Relations. Today's call is being recorded. Speaking first today is Apple's CEO, Tim Cook, and he'll be followed by CFO, Luca Maestri. After that, we'll open the call to questions from analysts. Please note that some of the information you'll hear during our discussion today will consist of forward-looking statements, including, without limitation, those regarding revenue, gross margin, operating expenses, other income and expense, taxes, capital allocation and future business outlook, including the potential impact of macroeconomic conditions on the company's business and results of operations. These statements involve risks and uncertainties that may cause actual results or trends to differ materially from our forecast. For more information, please refer to the risk factors discussed in Apple's most recently filed Annual Report on Form 10-K and the Form 8-K filed with the SEC today, along with the associated press release. Apple assumes no obligation to update any forward-looking statements, which speak only as of the date they are made. I'd now like to turn the call over to Tim for introductory remarks."
        },
        {
            "paragraphNumber": 2,
            "speaker": "Tim Cook",
            "content": "Thank you, Suhasini. Good afternoon, everyone, and thanks for joining the call. Today, Apple is reporting revenue of $90.8 billion and an EPS record of $1.53 for the March quarter. We set revenue records in more than a dozen countries and regions. These include, among others, March quarter records in Latin-America and the Middle East, as well as Canada, India, Spain and Turkey. We also achieved an all-time revenue record in Indonesia, one of the many markets where we continue to see so much potential. In services, we set an all-time revenue record, up 14% over the past year. Keep in mind, as we described on the last call, in the March quarter a year-ago, we were able to replenish iPhone channel inventory and fulfill significant pent-up demand from the December quarter COVID-related supply disruptions on the iPhone 14 Pro and 14 Pro Max. We estimate this one-time impact added close to $5 billion to the March quarter revenue last year. If we remove this from last year's results, our March quarter total company revenue this year would have grown. Despite this impact, we were still able to deliver the records I described. Of course, this past quarter, we were thrilled to launch Apple Vision Pro and it has been so wonderful to hear from people who now get to experience the magic of spatial computing. They describe the impossible becoming possible right before their eyes and they share their amazement and their emotions about what they can do now, whether it's reliving their most treasured memories or having a movie theater experience right in their living room. It's also great to see the enthusiasm from the enterprise market. For example, more than half of the Fortune 100 companies have already bought Apple Vision Pro units and are exploring innovative ways to use it to do things that weren't possible before, and this is just the beginning. Looking ahead, we're getting ready for an exciting product announcement next week that we think our customers will love. And next month, we have our Worldwide Developers Conference, which has generated enormous enthusiasm from our developers. We can't wait to reveal what we have in-store. We continue to feel very bullish about our opportunity in Generative AI. We are making significant investments, and we're looking forward to sharing some very exciting things with our customers soon. We believe in the transformative power and promise of AI, and we believe we have advantages that will differentiate us in this new era, including Apple's unique combination of seamless hardware, software and services integration, groundbreaking Apple's silicon, with our industry-leading neural engines and our unwavering focus on privacy, which underpins everything we create. As we push innovation forward, we continue to manage thoughtfully and deliberately through an uneven macroeconomic environment and remain focused on putting our users at the center of everything we do. Now let's turn to our results for the March quarter across each product category, beginning with iPhone. iPhone revenue for the March quarter was $46 billion, down 10% year-over-year. We faced a difficult compare over the previous year due to the $5 billion impact that I mentioned earlier. However, we still saw growth on iPhone in some markets, including Mainland China, and according to Kantar during the quarter, the two best-selling smartphones in Urban China were the iPhone 15 and iPhone 15 Pro Max. I was in China recently where I had the chance to meet with developers and creators who are doing remarkable things with iPhone. And just a couple of weeks ago, I visited Vietnam, Indonesia and Singapore, where it was incredible to see all the ways customers and communities are using our products and services to do amazing things. Everywhere I travel, people have such a great affinity for Apple, and it's one of the many reasons I'm so optimistic about the future. Turning to Mac. March quarter revenue was $7.5 billion, up 4% from a year ago. We had an amazing launch in early March with the new 13-inch and 15-inch MacBook Air. The world's most popular laptop is the best consumer laptop for AI with breakthrough performance of the M3 chip and it's even more powerful neural engine. Whether it's an entrepreneur starting a new business or a college student finishing their degree, users depend on the power and portability of MacBook Air to take them places they couldn't have gone without it. In iPad, revenue for the March quarter was $5.6 billion, 17% lower year-over-year, due to a difficult compare with the momentum following the launch of M2 iPad Pro and the 10th Generation iPad last fiscal year. iPad continues to stand apart for its versatility, power and performance. For video editors, music makers and creatives of all kinds, iPad is empowering users to do more than they ever could with a tablet. Across Wearables, Home and Accessories, March quarter revenue was $7.9 billion, down 10% from a year-ago due to a difficult launch compare on Watch and AirPods. Apple Watch is helping runners go the extra mile on their wellness journeys, keeping hikers on course with the latest navigation capabilities in watchOS 10, and enabling users of all fitness levels to live a healthier day. Across our watch lineup, we're harnessing AI and machine-learning to power lifesaving features like a regular rhythm notifications and fall detection. I often hear about how much these features mean to users and their loved ones and I'm thankful that so many people are able to get help in their time of greatest need. As I shared earlier, we set an all-time revenue record in services with $23.9 billion, up 14% year-over-year. We also achieved all-time revenue records across several categories and geographic segments. Audiences are tuning in on screens large, small and spatial and are enjoying Apple TV+ Originals like Palm Royale and Sugar. And we have some incredible theatrical releases coming this year, including Wolves, which reunites George Clooney and Brad Pitt. Apple TV+ productions continue to be celebrated as major awards contenders. Since launch, Apple TV+ productions have earned more than 2,100 award nominations and 480 wins. Meanwhile, we're enhancing the live sports experience with a new iPhone app, Apple Sports. This free app allows fans to follow their favorite teams and leagues with real-time scores, stats and more. Apple Sports is the perfect companion for MLS Season Pass subscribers. Turning to retail, our stores continued to be vital spaces for connection and innovation. I was delighted to be in Shanghai for the opening of our latest flagship store. The energy and enthusiasm from our customers was truly something to behold. And across the United States, our incredible retail teams have been sharing Vision Pro demos with customers, delighting them with a profound and emotional experience of using it for the very first time. Everywhere we operate and everything we do, we're guided by our mission to enrich users' lives and lead the world better than we found it, whether we're making Apple podcasts more accessible with a new transcripts feature or helping to safeguard iMessage users' privacy with new protections that can defend against advances in quantum computing. Our environmental work is another great example of how innovation and our values come together. As we work toward our goal of being carbon-neutral across all of our products by 2030, we are proud of how we've been able to innovate and do more for our customers while taking less from the planet. Since 2015, Apple has cut our overall emissions by more than half, while revenue grew nearly 65% during that same time period. And we're now using more recycled materials in our products than ever before. Earlier this spring, we launched our first-ever product to use 50% recycled materials with a new M3-powered MacBook Air. We're also investing in new solar and wind power in the U.S. and Europe, both to power our growing operations and our users' devices. And we're working with partners in India and the U.S. to replenish 100% of the water we use in places that need it most with the goal of delivering billions of gallons of water benefits over the next two decades. Through our Restore Fund, Apple has committed $200 million to nature-based carbon removal projects. And last month, we welcomed two supplier partners as new investors, who will together invest up to an additional $80 million in the fund. Whether we're enriching lives of users across the globe or doing our part to be a force for good in the world, we do everything with a deep sense of purpose at Apple. And I'm proud of the impact we've already made at the halfway point in a year of unprecedented innovation. I couldn't be more excited for the future we have ahead of us, driven by the imagination and innovation of our teams and the enduring importance of our products and services in people's lives. With that, I'll turn it over to Luca."
        },
        {
            "paragraphNumber": 3,
            "speaker": "Luca Maestri",
            "content": "Thank you, Tim, and good afternoon, everyone. Revenue for the March quarter was $90.8 billion, down 4% from last year. Foreign exchange had a negative year-over-year impact of 140 basis points on our results. Products revenue was $66.9 billion, down 10% year-over-year due to the challenging compare on iPhone that Tim described earlier, which was partially offset by strength from Mac. And thanks to our unparalleled customer satisfaction and loyalty and a high number of customers who are new to our products, our installed base of active devices reached an all-time high across all products and all geographic segments. Services revenue set an all-time record of $23.9 billion, up 14% year-over-year with record performance in both developed and emerging markets. Company gross margin was 46.6%, up 70 basis points sequentially, driven by cost savings and favorable mix to services, partially offset by leverage. Products gross margin was 36.6%, down 280 basis points sequentially, primarily driven by seasonal loss of leverage and mix, partially offset by favorable costs. Services gross margin was 74.6%, up 180 basis points from last quarter due to a more favorable mix. Operating expenses of $14.4 billion were at the midpoint of the guidance range we provided and up 5% year-over-year. Net income was $23.6 billion, diluted EPS was $1.53 and a March quarter record, and operating cash flow was strong at $22.7 billion. Let me now provide more detail for each of our revenue categories. iPhone revenue was $46 billion, down 10% year-over-year, due to the almost $5 billion impact from a year ago that Tim described earlier. Adjusting for this one-time impact, iPhone revenue would be roughly flat to last year. Our iPhone active installed base grew to a new all-time high in total and in every geographic segment. And during the March quarter, we saw many iPhone models as the top-selling smartphones around the world. In fact, according to a survey from Kantar, an iPhone was the top-selling model in the U.S., Urban China, Australia, the U.K., France, Germany and Japan. And the iPhone 15 family continues to be very popular with customers. 451 Research recently measured customer satisfaction at 99% in the U.S. Mac revenue was $7.5 billion, up 4% year-over-year, driven by the strength of our new MacBook Air, powered by the M3 chip. Customers are loving the incredible AI performance of the latest MacBook Air and MacBook Pro models. And our Mac installed base reached an all-time high with half of our MacBook Air buyers during the quarter being new to Mac. Also customer satisfaction for Mac was recently reported at 96% in the U.S. iPad generated $5.6 billion in revenue, down 17% year-over-year. iPad continued to face a challenging compare against the launch of the M2 iPad Pro and iPad 10th Generation from last year. At the same time, the iPad installed base has continued to grow and is at an all-time high as over half of the customers who purchased iPads during the quarter were new to the product. In addition, the latest reports from 451 Research indicated customer satisfaction of 96% for iPad in the US. Wearables, Home and Accessories revenue was $7.9 billion, down 10% year-over-year due to a difficult launch compare. Last year, we had the continued benefit from the launches of the AirPods Pro second-generation, the Watch SE and the first Watch Ultra. Apple Watch continues to attract new customers, with almost two-thirds of customers purchasing an Apple Watch during the quarter being new to the product, sending the Apple Watch installed base to a new all-time high and customer satisfaction was recently measured at 95% in the U.S. In services, as I mentioned, total revenue reached an all-time record of $23.9 billion, growing 14% year-over-year with our installed-base of active devices continuing to grow at a nice pace. This provides a strong foundation for the future growth of the services business as we continued to see increased customer engagement with our ecosystem. Both transacting accounts and paid accounts reached a new all-time high with paid accounts growing double-digits year-over-year. And paid subscriptions showed strong double-digit growth. We have well over $1 billion paid subscriptions across the services on our platform, more than double the number that we had only four years ago. We continued to improve the breadth and quality of our current services from creating new games on Arcade and great new shows on TV+ to launching additional countries and partners for Apple Pay. Turning to enterprise, our customers continued to invest in Apple products to drive productivity and innovation. We see more and more enterprise customers embracing the Mac. In Healthcare, Epic Systems, the world's largest electronic medical record provider, recently launched its native app for the Mac, making it easier for healthcare organizations like Emory Health to transition thousands of PCs to the Mac for clinical use. And since the launch of Vision Pro last quarter, many leading enterprise customers have been investing in this amazing new product to bring spatial computing apps and experiences to life. We are seeing so many compelling use cases from aircraft engine maintenance training at KLM Airlines to real-time team collaboration for racing at Porsche to immersive kitchen design at Lowe's. We couldn't be more excited about the spatial computing opportunity in enterprise. Taking a quick step back, when we look at our performance during the first-half of our fiscal year, total company revenue was roughly flat to the prior year in spite of having one less week of sales during the period and some foreign exchange headwinds. We were particularly pleased with our strong momentum in emerging markets, as we set first-half revenue records in several countries and regions, including Latin-America, the Middle East, India, Indonesia, the Philippines and Turkey. These results, coupled with double-digit growth in services and strong levels of gross margin, drove a first half diluted EPS record of $3.71, up 9% from last year. Let me now turn to our cash position and capital return program. We ended the quarter with $162 billion in cash and marketable securities. We repaid $3.2 billion in maturing debt and commercial paper was unchanged sequentially, leaving us with total debt of $105 billion. As a result, net cash was $58 billion at the end of the quarter. During the quarter, we returned over $27 billion to shareholders, including $3.7 billion in dividends and equivalents and $23.5 billion through open-market repurchases of $130 million Apple's shares. Given the continued confidence we have in our business now and into the future, our Board has authorized today an additional $110 billion for share repurchases, as we maintain our goal of getting to net cash-neutral over time. We are also raising our dividend by 4% to $0.25 per share of common stock, and we continued to plan for annual increases in the dividend going forward as we've done for the last 12 years. This cash dividend will be payable on May 16, 2024 to shareholders of record as of May 13, 2024. As we move ahead into the June quarter, I'd like to review our outlook, which includes the types of forward-looking information that Suhasini referred to at the beginning of the call. The color we are providing today assumes that the macroeconomic outlook doesn't worsen from what we are projecting today for the current quarter. We expect our June quarter total company revenue to grow low-single-digits year-over-year in spite of a foreign exchange headwind of about 2.5 percentage points. We expect our services business to grow double-digits at a rate similar to the growth we reported for the first-half of the fiscal year. And we expect iPad revenue to grow double-digits. We expect gross margin to be between 45.5% to -- and 46.5%. We expect OpEx to be between $14.3 billion and $14.5 billion. We expect OI&E to be around $50 million, excluding any potential impact from the mark-to-market of minority investments and our tax rate to be around 16%. With that, let's open the call to questions."
        },
        {
            "paragraphNumber": 4,
            "speaker": "Suhasini Chandramouli",
            "content": "Thank you, Luca. We ask that you limit yourself to two questions. Operator, may we have the first question, please?"
        },
        {
            "paragraphNumber": 5,
            "speaker": "Operator",
            "content": "Certainly. We will go ahead and take our first question from Mike Ng with Goldman Sachs. Please go ahead."
        },
        {
            "paragraphNumber": 6,
            "speaker": "Mike Ng",
            "content": "Hey, good afternoon. Thank you very much for the question. I have two, first, I'll ask about the June quarter guidance. The revenue outlook for low-single digits growth, I was wondering if you could run through some of the product assumptions, iPhone, like what kind of gives you confidence around that? And then on the service momentum, what was better than expected in the quarter? And then I just have a quick follow-up."
        },
        {
            "paragraphNumber": 7,
            "speaker": "Luca Maestri",
            "content": "Hey, Mike. It's Luca. On the outlook, what we said is we expect to grow low-single-digits in total for the company. We expect services to grow double-digits at a rate that is similar to what we've done in the first-half of our fiscal year. And we've also mentioned that iPad should grow double-digits. This is the color that we're providing for the June quarter. In services, we've seen a very strong performance across the board. We've mentioned, we've had records in several categories, in several geographic segments. It's very broad based, our subscription business is going well. Transacting accounts and paid accounts are growing double-digits. And also we've seen a really strong performance both in developed and emerging markets. So very pleased with the way the services business is going."
        },
        {
            "paragraphNumber": 8,
            "speaker": "Mike Ng",
            "content": "Great. Thank you. And I wanted to ask about, as Apple leans more into AI and Generative AI, should we expect any changes to the historical CapEx cadence that we've seen in the last few years of about $10 billion to $11 billion per year or any changes to, you know, how we may have historically thought about the split between tooling, data center and facilities? Thank you very much."
        },
        {
            "paragraphNumber": 9,
            "speaker": "Luca Maestri",
            "content": "Yes. We are obviously very excited about the opportunity with Gen AI. We obviously are pushing very hard on innovation on every front and we've been doing that for many, many years. Just during the last five years, we spent more than a $100 billion in research and development. As you know, on the CapEx front, we have a bit of a hybrid model where we make some of the investments ourselves. In other cases, we share them with our suppliers and partners on the manufacturing side, we purchased some of the tools and manufacturing equipment. In some of the cases, our suppliers make the investment. On the -- and we do something similar on the data center side. We have our own data center capacity and then we use capacity from third parties. It's a model that has worked well for us historically and we plan to continue along the same lines going forward."
        },
        {
            "paragraphNumber": 10,
            "speaker": "Mike Ng",
            "content": "Excellent. Thank you very much."
        },
        {
            "paragraphNumber": 11,
            "speaker": "Suhasini Chandramouli",
            "content": "Awesome. Thank you, Mike. Operator, can we have the next question, please?"
        },
        {
            "paragraphNumber": 12,
            "speaker": "Operator",
            "content": "Our next question is from Wamsi Mohan with Bank of America. Please go ahead."
        }
    ]
}
`,
  "03-fundamentals/filings/document-sentiment": `{
  "label": "NEGATIVE",
  "score": 0.984021182571139,
  "breakdown": {
    "positive": {
      "count": 63,
      "avgScore": 0.987096269925435
    },
    "negative": {
      "count": 293,
      "avgScore": 0.984021182571139
    }
  }
}`,
  "03-fundamentals/earnings/transcript-sentiment": `{
  "label": "POSITIVE",
  "score": 0.9626,
  "breakdown": {
    "positive": {
      "count": 5063,
      "avgScore": 0.9626
    },
    "negative": {
      "count": 1878,
      "avgScore": 0.9698
    }
  }
}`,
  "03-fundamentals/earnings/trend-1": `[
  {
    "period": "0q",
    "endDate": "2025-12-31T00:00:00.000Z",
    "growth": 0.1103,
    "earningsEstimate": {
      "avg": 2.66574,
      "low": 2.51,
      "high": 2.8,
      "yearAgoEps": 2.4,
      "numberOfAnalysts": 29,
      "growth": 0.1107
    },
    "revenueEstimate": {
      "avg": 138253076640,
      "low": 136679500000,
      "high": 142741000000,
      "numberOfAnalysts": 29,
      "yearAgoRevenue": 124300000000,
      "growth": 0.1123
    },
    "epsTrend": {
      "current": 2.66574,
      "7daysAgo": 2.66367,
      "30daysAgo": 2.66153,
      "60daysAgo": 2.48232,
      "90daysAgo": 2.492
    },
    "epsRevisions": {
      "upLast7days": 1,
      "upLast30days": 1,
      "downLast30days": 0,
      "downLast7Days": 0
    }
  }
]`,
  "03-fundamentals/earnings/trend-2": `{
  "symbol": "SP5",
  "estimates": [
    {
      "period": "0q",
      "growth": 0.1524
    },
    {
      "period": "+1q",
      "growth": 0.070300005
    },
    {
      "period": "0y",
      "growth": 0.109
    },
    {
      "period": "+1y",
      "growth": 0.1487
    },
    {
      "period": "LTG",
      "growth": 0.122
    }
  ]
}`,
  "03-fundamentals/earnings/trend-3": `[
  {
    "dataframe": [
      {
        "label": "December 30, 2023",
        "values": [ "September 30, 2023" ]
      },
      {
        "label": "ASSETS:",
        "values": []
      },
      {
        "label": "Current assets:",
        "values": []
      },
      {
        "label": "Cash and cash equivalents",
        "values": [ "$", 40760, "$", 29965 ]
      },
      {
        "label": "Marketable securities",
        "values": [ 32340, 31590 ]
      },
      {
        "label": "Total current assets",
        "values": [ 143692, 143566 ]
      },
      {
        "label": "Total assets",
        "values": [ "$", 353514, "$", 352583 ]
      }
    ],
    "scale": 1000000000,
    "title": null,
    "statementType": "balance_sheet",
    "periods": [ "Period 1" ],
    "rawIndex": 5
  },
  {
    "dataframe": [
      {
        "label": "Three Months Ended",
        "values": []
      },
      {
        "label": "December 30, 2023",
        "values": [ "December 31, 2022" ]
      },
      {
        "label": "Cash generated by operating activities",
        "values": [ 39895, 34005 ]
      },
      {
        "label": "Cash generated by/(used in) investing activities",
        "values": [ 1927, -1445 ]
      },
      {
        "label": "Cash used in financing activities",
        "values": [ -30585, -35563 ]
      }
    ],
    "scale": 1000000000,
    "title": null,
    "statementType": "cash_flow",
    "periods": [],
    "rawIndex": 6
  }
]`,
  "03-fundamentals/filings/00-list-forms": `[
  "all",
  "10-K",
  "10-Q",
  "8-K",
  "4",
  "3",
  "S-1",
  "S-3",
  "DEF 14A",
  "13F-HR",
  "SC 13G",
  "SC 13D",
  "144",
  "NPORT-P",
  "NPORT-EX"
]`,
  "03-fundamentals/filings/by-company": `[
  {
    "cik": 320193,
    "form": "4",
    "filingDate": "2026-01-15",
    "accessionNumber": "000032019326000015",
    "documentId": "aHR0cHM6Ly93d3cuc2VjLmdvdi9BcmNoaXZlcy9lZGdhci9kYXRhLzMyMDE5My8wMDAwMzIwMTkzMjYwMDAwMTUvaW5kZXguaHRtbA==",
    "url": "https://www.sec.gov/Archives/edgar/data/320193/000032019326000015-index.html"
  },
  {
    "cik": 320193,
    "form": "10-Q",
    "filingDate": "2026-01-12",
    "accessionNumber": "000032019326000006",
    "documentId": "aHR0cHM6Ly93d3cuc2VjLmdvdi9BcmNoaXZlcy9lZGdhci9kYXRhLzMyMDE5My8wMDAwMzIwMTkzMjYwMDAwMDYvYWFwbC0yMDI1MTIyNy5odG0=",
    "url": "https://www.sec.gov/Archives/edgar/data/320193/000032019326000006/aapl-20251227.htm"
  },
  {
    "cik": 320193,
    "form": "8-K",
    "filingDate": "2026-01-10",
    "accessionNumber": "000032019326000005",
    "documentId": "aHR0cHM6Ly93d3cuc2VjLmdvdi9BcmNoaXZlcy9lZGdhci9kYXRhLzMyMDE5My8wMDAwMzIwMTkzMjYwMDAwMDUvYWFwbC0yMDI2MDEyOS5odG0=",
    "url": "https://www.sec.gov/Archives/edgar/data/320193/000032019326000005/aapl-20260129.htm"
  }
]`,
  "03-fundamentals/filings/by-company-1": `[
  {
    "company": "Apple Inc.",
    "cik": 320193,
    "form": "4",
    "filingDate": "2026-01-15",
    "reportDate": "2026-01-14",
    "accessionNumber": "000032019326000015",
    "documentId": "aHR0cHM6Ly93d3cuc2VjLmdvdi9BcmNoaXZlcy9lZGdhci9kYXRhLzMyMDE5My8wMDAwMzIwMTkzMjYwMDAwMTUvaW5kZXguaHRtbA==",
    "url": "https://www.sec.gov/Archives/edgar/data/320193/000032019326000015-index.html"
  },
  {
    "company": "Apple Inc.",
    "cik": 320193,
    "form": "4",
    "filingDate": "2026-01-14",
    "reportDate": "2026-01-13",
    "accessionNumber": "000032019326000014",
    "documentId": "aHR0cHM6Ly93d3cuc2VjLmdvdi9BcmNoaXZlcy9lZGdhci9kYXRhLzMyMDE5My8wMDAwMzIwMTkzMjYwMDAwMTQvaW5kZXguaHRtbA==",
    "url": "https://www.sec.gov/Archives/edgar/data/320193/000032019326000014-index.html"
  }
]`,
  "03-fundamentals/filings/by-date": `[
  {
    "company": "Apple Inc.",
    "cik": 320193,
    "form": "4",
    "filingDate": "2024-01-15",
    "accessionNumber": "000032019324000015",
    "documentId": "aHR0cHM6Ly93d3cuc2VjLmdvdi9BcmNoaXZlcy9lZGdhci9kYXRhLzMyMDE5My8wMDAwMzIwMTkzMjQwMDAwMTUvaW5kZXguaHRtbA==",
    "url": "https://www.sec.gov/Archives/edgar/data/320193/000032019324000015-index.html"
  },
  {
    "company": "Apple Inc.",
    "cik": 320193,
    "form": "4",
    "filingDate": "2024-01-14",
    "accessionNumber": "000032019324000014",
    "documentId": "aHR0cHM6Ly93d3cuc2VjLmdvdi9BcmNoaXZlcy9lZGdhci9kYXRhLzMyMDE5My8wMDAwMzIwMTkzMjQwMDAwMTQvaW5kZXguaHRtbA==",
    "url": "https://www.sec.gov/Archives/edgar/data/320193/000032019324000014-index.html"
  }
]`,
  "03-fundamentals/filings/document-text": `{
  "src": "https://www.sec.gov/Archives/edgar/data/320193/0000320193-20-000010.txt",
  "text": "UNITED STATES\n\nSECURITIES AND EXCHANGE COMMISSION\n\nWashington, D.C. 20549\n\nFORM SD\n\nSpecialized Disclosure Report\n\nApple Inc.\n\n(Exact name of the registrant as specified in its charter)\n\nCalifornia\n\n001-36743\n\n94-2404110\n\n(State or other jurisdiction of incorporation or organization)\n\n(Commission File Number)\n\n(I.R.S. Employer Identification No.)\n\nOne Apple Park Way\n\nCupertino, California 95014\n\n(Address of principal executive offices) (Zip Code)\n\n..."
}`,
  "03-fundamentals/financials/assets": `[
  379297000000,
  359241000000,
  359241000000,
  331495000000
]`,
  "03-fundamentals/financials/assets-1": `[
  158104000000,
  147957000000,
  147957000000,
  122491000000
]`,
  "03-fundamentals/financials/cashflow": `[
  53925000000,
  111482000000,
  81754000000,
  53887000000
]`,
  "03-fundamentals/financials/cashflow-1": `[
  51552000000,
  98767000000,
  72281000000,
  47876000000
]`,
  "03-fundamentals/financials/cashflow-2": `[
  2373000000,
  12715000000,
  9473000000,
  6011000000
]`,
  "03-fundamentals/financials/equities": `[
  88190000000,
  73733000000,
  73733000000,
  65830000000
]`,
  "03-fundamentals/financials/income": `[
  42097000000,
  112010000000,
  84544000000,
  23434000000
]`,
  "03-fundamentals/financials/liabilities": `[
  291107000000,
  285508000000,
  285508000000,
  265665000000
]`,
  "03-fundamentals/financials/liabilities-1": `[
  162367000000,
  165631000000,
  165631000000,
  141120000000
]`,
  "03-fundamentals/financials/metrics": `{
  "revenue": 143756000000,
  "netIncome": 42097000000,
  "totalAssets": 379297000000,
  "totalLiabilities": 291107000000,
  "stockholdersEquity": 88190000000,
  "currentAssets": 158104000000,
  "currentLiabilities": 162367000000,
  "operatingCashFlow": 53925000000,
  "capitalExpenditures": 2373000000,
  "freeCashFlow": 51552000000,
  "sharesOutstandingBasic": 14748158000,
  "sharesOutstandingDiluted": 14810356000,
  "currentRatio": 0.973744664864166,
  "debtToAssets": 0.76749091081659
}`,
  "03-fundamentals/financials/revenue": `[
  143756000000,
  416161000000,
  313695000000,
  94036000000
]`,
  "03-fundamentals/financials/shares": `[
  14748158000,
  14948500000,
  14992898000,
  14902886000
]`,
  "03-fundamentals/financials/shares-1": `[
  14810356000,
  15004697000,
  15051726000,
  14948179000
]`,
  "03-fundamentals/financials/snapshot": `{
  "currentPrice": 272.19,
  "targetHighPrice": 350,
  "targetLowPrice": 215,
  "targetMeanPrice": 287.70682,
  "targetMedianPrice": 300,
  "recommendationMean": 2,
  "recommendationKey": "buy",
  "numberOfAnalystOpinions": 41,
  "totalCash": 54697000960,
  "totalCashPerShare": 3.702,
  "ebitda": 144748003328,
  "totalDebt": 112377004032,
  "quickRatio": 0.771,
  "currentRatio": 0.893,
  "totalRevenue": 416161005568,
  "debtToEquity": 152.411,
  "revenuePerShare": 27.84,
  "returnOnAssets": 0.22964,
  "returnOnEquity": 1.7142199,
  "grossProfits": 195201007616,
  "freeCashflow": 78862254080,
  "operatingCashflow": 111482003456,
  "earningsGrowth": 0.912,
  "revenueGrowth": 0.079,
  "grossMargins": 0.46905,
  "ebitdaMargins": 0.34782,
  "operatingMargins": 0.31647,
  "profitMargins": 0.26915002,
  "financialCurrency": "USD"
}`,
  "03-fundamentals/financials/dcf-value": `{
  "enterpriseValue": 3953331149665.99,
  "cash": 68507000000,
  "totalDebt": 111088000000,
  "equityValue": 3910750149665.99,
  "sharesOutstanding": 14687356000,
  "fairPrice": 266.27,
  "currentPrice": 315.32,
  "marginOfSafety": -0.18,
  "recommendation": "Sell"
}`,
  "03-fundamentals/financials/eps-historical": `[
  {
    "reportDate": "2024-12-31",
    "tailingEps": 6.29
  },
  {
    "reportDate": "2025-03-31",
    "tailingEps": 6.41
  },
  {
    "reportDate": "2025-06-30",
    "tailingEps": 6.58
  },
  {
    "reportDate": "2025-09-30",
    "tailingEps": 7.46
  },
  {
    "reportDate": "2025-12-31",
    "tailingEps": 7.9
  },
  {
    "reportDate": "2026-03-31",
    "tailingEps": 8.27
  }
]`,
  "03-fundamentals/financials/pe-historical": `[
  {
    "reportDate": "2026-07-06",
    "epsReportDate": "2026-03-31",
    "closePrice": 312.66,
    "ttmEps": 8.27,
    "ttmPe": 37.82
  },
  {
    "reportDate": "2026-07-07",
    "epsReportDate": "2026-03-31",
    "closePrice": 310.66,
    "ttmEps": 8.27,
    "ttmPe": 37.58
  },
  {
    "reportDate": "2026-07-08",
    "epsReportDate": "2026-03-31",
    "closePrice": 313.39,
    "ttmEps": 8.27,
    "ttmPe": 37.91
  },
  {
    "reportDate": "2026-07-09",
    "epsReportDate": "2026-03-31",
    "closePrice": 316.22,
    "ttmEps": 8.27,
    "ttmPe": 38.25
  },
  {
    "reportDate": "2026-07-10",
    "epsReportDate": "2026-03-31",
    "closePrice": 315.32,
    "ttmEps": 8.27,
    "ttmPe": 38.14
  },
  {
    "reportDate": "2026-07-13",
    "epsReportDate": "2026-03-31",
    "closePrice": 317.31,
    "ttmEps": 8.27,
    "ttmPe": 38.38
  }
]`,
  "03-fundamentals/financials/marketcap-historical": `[
  {
    "reportDate": "2026-07-02",
    "sharesReportDate": "2026-04-17",
    "closePrice": 308.63,
    "sharesOutstanding": 14687356000,
    "marketCapitalization": 4532958682280
  },
  {
    "reportDate": "2026-07-06",
    "sharesReportDate": "2026-04-17",
    "closePrice": 312.66,
    "sharesOutstanding": 14687356000,
    "marketCapitalization": 4592148726960
  },
  {
    "reportDate": "2026-07-07",
    "sharesReportDate": "2026-04-17",
    "closePrice": 310.66,
    "sharesOutstanding": 14687356000,
    "marketCapitalization": 4562774014960
  },
  {
    "reportDate": "2026-07-08",
    "sharesReportDate": "2026-04-17",
    "closePrice": 313.39,
    "sharesOutstanding": 14687356000,
    "marketCapitalization": 4602870496840
  },
  {
    "reportDate": "2026-07-09",
    "sharesReportDate": "2026-04-17",
    "closePrice": 316.22,
    "sharesOutstanding": 14687356000,
    "marketCapitalization": 4644435714320
  },
  {
    "reportDate": "2026-07-10",
    "sharesReportDate": "2026-04-17",
    "closePrice": 315.32,
    "sharesOutstanding": 14687356000,
    "marketCapitalization": 4631217093920
  },
  {
    "reportDate": "2026-07-13",
    "sharesReportDate": "2026-04-17",
    "closePrice": 317.31,
    "sharesOutstanding": 14687356000,
    "marketCapitalization": 4660444932360
  }
]`,
  "03-fundamentals/financials/roe-historical": `[
  {
    "reportDate": "2024-12-31",
    "netIncomeCommonStockholders": 36330000000,
    "beginningStockholdersEquity": 56950000000,
    "endingStockholdersEquity": 66758000000,
    "avgEquity": 61854000000,
    "roe": 0.5874
  },
  {
    "reportDate": "2025-03-31",
    "netIncomeCommonStockholders": 24780000000,
    "beginningStockholdersEquity": 66758000000,
    "endingStockholdersEquity": 66796000000,
    "avgEquity": 66777000000,
    "roe": 0.3711
  },
  {
    "reportDate": "2025-06-30",
    "netIncomeCommonStockholders": 23434000000,
    "beginningStockholdersEquity": 66796000000,
    "endingStockholdersEquity": 65830000000,
    "avgEquity": 66313000000,
    "roe": 0.3534
  },
  {
    "reportDate": "2025-09-30",
    "netIncomeCommonStockholders": 27466000000,
    "beginningStockholdersEquity": 65830000000,
    "endingStockholdersEquity": 73733000000,
    "avgEquity": 69781500000,
    "roe": 0.3936
  },
  {
    "reportDate": "2025-12-31",
    "netIncomeCommonStockholders": 42097000000,
    "beginningStockholdersEquity": 73733000000,
    "endingStockholdersEquity": 88190000000,
    "avgEquity": 80961500000,
    "roe": 0.52
  },
  {
    "reportDate": "2026-03-31",
    "netIncomeCommonStockholders": 29578000000,
    "beginningStockholdersEquity": 88190000000,
    "endingStockholdersEquity": 106491000000,
    "avgEquity": 97340500000,
    "roe": 0.3039
  }
]`,
  "03-fundamentals/financials/ev-historical": `[
  {
    "reportDate": "2026-06-24",
    "marketCapitalization": 4304570296480,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4343709296480
  },
  {
    "reportDate": "2026-06-25",
    "marketCapitalization": 4041226003400,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4080365003400
  },
  {
    "reportDate": "2026-06-26",
    "marketCapitalization": 4167977885680,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4207116885680
  },
  {
    "reportDate": "2026-06-29",
    "marketCapitalization": 4138015679440,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4177154679440
  },
  {
    "reportDate": "2026-06-30",
    "marketCapitalization": 4249933332160,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4289072332160
  },
  {
    "reportDate": "2026-07-01",
    "marketCapitalization": 4323663859280,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4362802859280
  },
  {
    "reportDate": "2026-07-02",
    "marketCapitalization": 4532958682280,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4572097682280
  },
  {
    "reportDate": "2026-07-06",
    "marketCapitalization": 4592148726960,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4631287726960
  },
  {
    "reportDate": "2026-07-07",
    "marketCapitalization": 4562774014960,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4601913014960
  },
  {
    "reportDate": "2026-07-08",
    "marketCapitalization": 4602870496840,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4642009496840
  },
  {
    "reportDate": "2026-07-09",
    "marketCapitalization": 4644435714320,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4683574714320
  },
  {
    "reportDate": "2026-07-10",
    "marketCapitalization": 4631217093920,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4670356093920
  },
  {
    "reportDate": "2026-07-13",
    "marketCapitalization": 4660444932360,
    "totalDebt": 84711000000,
    "cashAndCashEquivalents": 45572000000,
    "enterpriseValue": 4699583932360
  }
]`,
  "03-fundamentals/financials/ebitda-historical": `[
  {
    "reportDate": "2025-06-30",
    "ttmEbitda": 141696000000,
    "reportDateEbitda": {
      "2024-09-30": 32502000000,
      "2024-12-31": 45912000000,
      "2025-03-31": 32250000000,
      "2025-06-30": 31032000000
    },
    "exchangeToUsdRate": 1,
    "ttmEbitdaUsd": 141696000000
  },
  {
    "reportDate": "2025-09-30",
    "ttmEbitda": 144748000000,
    "reportDateEbitda": {
      "2024-12-31": 45912000000,
      "2025-03-31": 32250000000,
      "2025-06-30": 31032000000,
      "2025-09-30": 35554000000
    },
    "exchangeToUsdRate": 1,
    "ttmEbitdaUsd": 144748000000
  },
  {
    "reportDate": "2025-12-31",
    "ttmEbitda": 152902000000,
    "reportDateEbitda": {
      "2025-03-31": 32250000000,
      "2025-06-30": 31032000000,
      "2025-09-30": 35554000000,
      "2025-12-31": 54066000000
    },
    "exchangeToUsdRate": 1,
    "ttmEbitdaUsd": 152902000000
  },
  {
    "reportDate": "2026-03-31",
    "ttmEbitda": 159976000000,
    "reportDateEbitda": {
      "2025-06-30": 31032000000,
      "2025-09-30": 35554000000,
      "2025-12-31": 54066000000,
      "2026-03-31": 39324000000
    },
    "exchangeToUsdRate": 1,
    "ttmEbitdaUsd": 159976000000
  }
]`,
  "03-fundamentals/financials/de-historical": `[
  {
    "reportDate": "2024-09-30",
    "totalDebt": 106629000000,
    "stockholdersEquity": 56950000000,
    "debtToEquity": 1.87
  },
  {
    "reportDate": "2024-12-31",
    "totalDebt": 96799000000,
    "stockholdersEquity": 66758000000,
    "debtToEquity": 1.45
  },
  {
    "reportDate": "2025-03-31",
    "totalDebt": 98186000000,
    "stockholdersEquity": 66796000000,
    "debtToEquity": 1.47
  },
  {
    "reportDate": "2025-06-30",
    "totalDebt": 101698000000,
    "stockholdersEquity": 65830000000,
    "debtToEquity": 1.54
  },
  {
    "reportDate": "2025-09-30",
    "totalDebt": 98657000000,
    "stockholdersEquity": 73733000000,
    "debtToEquity": 1.34
  },
  {
    "reportDate": "2025-12-31",
    "totalDebt": 90509000000,
    "stockholdersEquity": 88190000000,
    "debtToEquity": 1.03
  },
  {
    "reportDate": "2026-03-31",
    "totalDebt": 84711000000,
    "stockholdersEquity": 106491000000,
    "debtToEquity": 0.8
  }
]`,
  "03-fundamentals/financials/dcf-rate": `{
  "marketCap": 4631217093920,
  "beta5y": 1.0839,
  "totalDebt": 111088000000,
  "interestExpense": 1002000000,
  "pretaxIncome": 26998000000,
  "taxProvision": 4042000000,
  "riskFreeRate": 0.0353,
  "weightOfDebt": 0.0234,
  "weightOfEquity": 0.9766,
  "costOfDebt": 0.009,
  "costOfEquity": 0.1054,
  "taxRate": 0.15,
  "wacc": 0.1031
}`,
  "03-fundamentals/insiders/activity": `{
  "period": "6m",
  "buyInfoCount": 8,
  "buyInfoShares": 582428,
  "buyPercentInsiderShares": 0.002,
  "sellInfoCount": 7,
  "sellInfoShares": 352873,
  "sellPercentInsiderShares": 0.001,
  "netInfoCount": 15,
  "netInfoShares": 229555,
  "netPercentInsiderShares": 0.001,
  "totalInsiderShares": 250754720
}`,
  "03-fundamentals/insiders/funds": `[
  {
    "reportDate": "2025-09-30T00:00:00.000Z",
    "organization": "VANGUARD INDEX FUNDS-Vanguard Total Stock Market Index Fund",
    "pctHeld": 0.031600002,
    "position": 467135722,
    "value": 127149673311,
    "pctChange": -0.0274
  },
  {
    "reportDate": "2025-09-30T00:00:00.000Z",
    "organization": "VANGUARD INDEX FUNDS-Vanguard 500 Index Fund",
    "pctHeld": 0.0248,
    "position": 366145920,
    "value": 99661258858,
    "pctChange": -0.1363
  }
]`,
  "03-fundamentals/insiders/individuals": `[
  {
    "name": "ADAMS KATHERINE L",
    "relation": "General Counsel",
    "url": "",
    "transactionDescription": "Stock Gift",
    "latestTransDate": "2025-11-12T00:00:00.000Z",
    "positionDirect": 175408,
    "positionDirectDate": "2025-11-12T00:00:00.000Z"
  },
  {
    "name": "COOK TIMOTHY D",
    "relation": "Chief Executive Officer",
    "url": "",
    "transactionDescription": "Sale",
    "latestTransDate": "2025-10-02T00:00:00.000Z",
    "positionDirect": 3280300,
    "positionDirectDate": "2025-10-02T00:00:00.000Z"
  }
]`,
  "03-fundamentals/insiders/institutions": `[
  {
    "reportDate": "2025-09-30T00:00:00.000Z",
    "organization": "Vanguard Group Inc",
    "pctHeld": 0.0947,
    "position": 1399427162,
    "value": 380910082641,
    "pctChange": -0.0117
  },
  {
    "reportDate": "2025-09-30T00:00:00.000Z",
    "organization": "Blackrock Inc.",
    "pctHeld": 0.0776,
    "position": 1146332274,
    "value": 312020184458,
    "pctChange": -0.0022
  }
]`,
  "03-fundamentals/insiders/major-holders": `{
  "insidersPercentHeld": 0.016970001,
  "institutionsPercentHeld": 0.64405996,
  "institutionsFloatPercentHeld": 0.65518,
  "institutionsCount": 7072
}`,
  "03-fundamentals/insiders/transactions": `[
  {
    "shares": 3750,
    "value": 0,
    "filerUrl": "",
    "transactionText": "Stock Gift at price 0.00 per share.",
    "filerName": "ADAMS KATHERINE L",
    "filerRelation": "General Counsel",
    "moneyText": "",
    "startDate": "2025-11-12T00:00:00.000Z",
    "ownership": "D"
  },
  {
    "shares": 3752,
    "value": 1017655,
    "filerUrl": "",
    "transactionText": "Sale at price 271.23 per share.",
    "filerName": "KONDO CHRISTOPHER",
    "filerRelation": "Officer",
    "moneyText": "",
    "startDate": "2025-11-07T00:00:00.000Z",
    "ownership": "D"
  }
]`,
  "04-macros-and-signals/calendar/corporate-events": `{
  "earnings": {
    "earningsDate": ["2026-01-29T21:00:00.000Z"],
    "earningsCallDate": ["2025-10-30T21:00:00.000Z"],
    "isEarningsDateEstimate": true,
    "earningsAverage": 2.6647,
    "earningsLow": 2.51,
    "earningsHigh": 2.76,
    "revenueAverage": 138253076640,
    "revenueLow": 136679500000,
    "revenueHigh": 142741000000
  },
  "exDividendDate": "2025-11-10T00:00:00.000Z",
  "dividendDate": "2025-11-13T00:00:00.000Z"
}`,
  "04-macros-and-signals/calendar/economic-calendar": `[
  {
    "id": "398637",
    "title": "S&P Global Manufacturing PMI Final",
    "country": "america",
    "code": "US",
    "indicator": "Manufacturing PMI",
    "ticker": null,
    "comment": "The S&P Global US Manufacturing PMI is compiled by S&P Global from responses to questionnaires sent to purchasing managers in a panel of around 800 manufacturers. The headline figure is the Purchasing Managers' Index (PMI), which is a weighted average of the following five indices: New Orders (30%), Output (25%), Employment (20%), Suppliers' Delivery Times (15%) and Stocks of Purchases (10%). For the PMI calculation the Suppliers' Delivery Times Index is inverted so that it moves in a comparable direction to the other indices. The index varies between 0 and 100, with a reading above 50 indicating an overall increase compared to the previous month, and below 50 an overall decrease. This is only a limited sample of PMI headline data displayed on the Customer's service, under licence from S&P Global. Full historic PMI headline data and all other PMI sub-index data and histories are available on subscription from S&P Global. Contact economics@spglobal.com for more details.",
    "category": null,
    "period": "Dec",
    "referenceDate": "2025-12-31T00:00:00.000Z",
    "source": "S&P Global",
    "sourceUrl": "https://www.pmi.spglobal.com/public",
    "actual": null,
    "previous": null,
    "forecast": "51.8",
    "actualRaw": null,
    "previousRaw": null,
    "forecastRaw": "51.8",
    "currency": "USD",
    "importance": -1,
    "date": "2026-01-02T14:45:00.000Z"
  },
  {
    "id": "397745",
    "title": "Fed Balance Sheet",
    "country": "america",
    "code": "US",
    "indicator": "Central Bank Balance Sheet",
    "ticker": "ECONOMICS:USCBBS",
    "comment": "The Central Bank Balance Sheet represents the total assets held by a central bank. It reflects the scale of monetary policy actions, including holdings like government securities, foreign reserves, and loans to banks. Changes in the balance sheet indicate shifts in policy, such as easing or tightening financial conditions.",
    "category": "mny",
    "period": "Dec/31",
    "referenceDate": "2025-12-31T00:00:00.000Z",
    "source": "Federal Reserve",
    "sourceUrl": "http://www.federalreserve.gov",
    "actual": "6.64",
    "previous": "6.56",
    "forecast": null,
    "actualRaw": "6640000000000",
    "previousRaw": "6560000000000",
    "forecastRaw": null,
    "currency": "USD",
    "importance": -1,
    "date": "2026-01-02T21:30:00.000Z"
  },
  {
    "id": "417834",
    "title": "Fed Paulson Speech",
    "country": "america",
    "code": "US",
    "indicator": "Interest Rate",
    "ticker": "ECONOMICS:USINTR",
    "comment": "In the United States, the authority to set interest rates is divided between the Board of Governors of the Federal Reserve (Board) and the Federal Open Market Committee (FOMC). The Board decides on changes in discount rates after recommendations submitted by one or more of the regional Federal Reserve Banks. The FOMC decides on open market operations, including the desired levels of central bank money or the desired federal funds market rate.",
    "category": "mny",
    "period": "",
    "referenceDate": null,
    "source": "Federal Reserve",
    "sourceUrl": "http://www.federalreserve.gov/",
    "actual": null,
    "previous": null,
    "forecast": null,
    "actualRaw": null,
    "previousRaw": null,
    "forecastRaw": null,
    "currency": "USD",
    "importance": 0,
    "date": "2026-01-03T15:15:00.000Z"
  },
  {
    "id": "417835",
    "title": "Fed Paulson Speech",
    "country": "america",
    "code": "US",
    "indicator": "Interest Rate",
    "ticker": "ECONOMICS:USINTR",
    "comment": "In the United States, the authority to set interest rates is divided between the Board of Governors of the Federal Reserve (Board) and the Federal Open Market Committee (FOMC). The Board decides on changes in discount rates after recommendations submitted by one or more of the regional Federal Reserve Banks. The FOMC decides on open market operations, including the desired levels of central bank money or the desired federal funds market rate.",
    "category": "mny",
    "period": "",
    "referenceDate": null,
    "source": "Federal Reserve",
    "sourceUrl": "http://www.federalreserve.gov/",
    "actual": null,
    "previous": null,
    "forecast": null,
    "actualRaw": null,
    "previousRaw": null,
    "forecastRaw": null,
    "currency": "USD",
    "importance": 0,
    "date": "2026-01-03T19:30:00.000Z"
  },
  {
    "id": "417836",
    "title": "Fed Kashkari Speech",
    "country": "america",
    "code": "US",
    "indicator": "Interest Rate",
    "ticker": "ECONOMICS:USINTR",
    "comment": "In the United States, the authority to set interest rates is divided between the Board of Governors of the Federal Reserve (Board) and the Federal Open Market Committee (FOMC). The Board decides on changes in discount rates after recommendations submitted by one or more of the regional Federal Reserve Banks. The FOMC decides on open market operations, including the desired levels of central bank money or the desired federal funds market rate.",
    "category": "mny",
    "period": "",
    "referenceDate": null,
    "source": "Federal Reserve",
    "sourceUrl": "http://www.federalreserve.gov/",
    "actual": null,
    "previous": null,
    "forecast": null,
    "actualRaw": null,
    "previousRaw": null,
    "forecastRaw": null,
    "currency": "USD",
    "importance": 0,
    "date": "2026-01-04T17:30:00.000Z"
  },
  {
    "id": "394699",
    "title": "ISM Manufacturing New Orders",
    "country": "america",
    "code": "US",
    "indicator": "ISM Manufacturing New Orders",
    "ticker": "ECONOMICS:USMNO",
    "comment": "The Manufacturing ISM Report On Business is based on data compiled from purchasing and supply executives nationwide. Survey responses reflect the change, if any, in the current month compared to the previous month. For each of the indicators measured (New Orders, Backlog of Orders, New Export Orders, Imports, Production, Supplier Deliveries, Inventories, Customers' Inventories, Employment and Prices), the report shows the percentage reporting each response, the net difference between the number of responses in the positive economic direction and the negative economic direction, and the diffusion index. A PMI reading above 50 percent indicates that the manufacturing economy is generally expanding; below 50 percent indicates that it is generally declining.",
    "category": "bsnss",
    "period": "Dec",
    "referenceDate": "2025-12-31T00:00:00.000Z",
    "source": "Institute for Supply Management",
    "sourceUrl": "https://www.ismworld.org",
    "actual": "47.7",
    "previous": "47.4",
    "forecast": null,
    "actualRaw": "47.7",
    "previousRaw": "47.4",
    "forecastRaw": null,
    "currency": "USD",
    "importance": -1,
    "date": "2026-01-05T15:00:00.000Z"
  }

]`,
  "04-macros-and-signals/credit-ratings/00-search": `[
  {
    "id": "689595",
    "name": "Apple Bidco, LLC",
    "sectorCode": "CORP",
    "country": "USA",
    "state": "Texas",
    "navigationUrl": null
  },
  {
    "id": "112354",
    "name": "Apple Inc.",
    "sectorCode": "CORP",
    "country": "USA",
    "state": "California",
    "navigationUrl": null
  }
]`,
  "04-macros-and-signals/credit-ratings/report": `[
  {
    "orgDebtTypeDesc": "Issuer Credit Rating",
    "rating": "B",
    "ratingDate": "06-Jul-2021",
    "currentCwOl": "Stable",
    "currentCwOlDate": "06-Jul-2021",
    "ratingDebtTypeCode": "ICR",
    "lastReviewDate": "11-Jun-2025",
    "coreOrgId": "689595",
    "endorsementIndicator": "EE|UKE",
    "coreRatingId": "937228060",
    "ratingTypeCode": "STDLONG",
    "ratingTypeCodeDesc": "Local Currency LT",
    "pcrFlag": true,
    "id": 1
  },
  {
    "orgDebtTypeDesc": "Issuer Credit Rating",
    "rating": "B",
    "ratingDate": "06-Jul-2021",
    "currentCwOl": "Stable",
    "currentCwOlDate": "06-Jul-2021",
    "ratingDebtTypeCode": "ICR",
    "lastReviewDate": "11-Jun-2025",
    "coreOrgId": "689595",
    "endorsementIndicator": "EE|UKE",
    "coreRatingId": "937228062",
    "ratingTypeCode": "FCLONG",
    "ratingTypeCodeDesc": "Foreign Currency LT",
    "pcrFlag": true,
    "id": 2
  }
]`,
  "04-macros-and-signals/economic-datasets/find": `[
  {
    "id": "IPG3344S",
    "realtimeStart": "2026-07-10",
    "realtimeEnd": "2026-07-10",
    "title": "Industrial Production: Manufacturing: Durable Goods: Semiconductor and Other Electronic Component (NAICS = 3344)",
    "observationStart": "1972-01-01",
    "observationEnd": "2026-05-01",
    "frequency": "Monthly",
    "frequencyShort": "M",
    "units": "Index 2017=100",
    "unitsShort": "Index 2017=100",
    "seasonalAdjustment": "Seasonally Adjusted",
    "seasonalAdjustmentShort": "SA",
    "lastUpdated": "2026-06-15 08:25:00-05",
    "popularity": "44",
    "notes": "explanatory notes issued by the Board of Governors."
  },
  {
    "id": "A34SNO",
    "realtimeStart": "2026-07-10",
    "realtimeEnd": "2026-07-10",
    "title": "Manufacturers' New Orders: Computers and Electronic Products",
    "observationStart": "1992-02-01",
    "observationEnd": "2026-05-01",
    "frequency": "Monthly",
    "frequencyShort": "M",
    "units": "Millions of Dollars",
    "unitsShort": "Mil. of $",
    "seasonalAdjustment": "Seasonally Adjusted",
    "seasonalAdjustmentShort": "SA",
    "lastUpdated": "2026-07-02 09:07:40-05",
    "popularity": "40",
    "notes": "Data on New Orders for the Semiconductor Industry are not available."
  },
  {
    "id": "CAPUTLG3344S",
    "realtimeStart": "2026-07-10",
    "realtimeEnd": "2026-07-10",
    "title": "Capacity Utilization: Manufacturing: Durable Goods: Semiconductor and Other Electronic Component (NAICS = 3344)",
    "observationStart": "1972-01-01",
    "observationEnd": "2026-05-01",
    "frequency": "Monthly",
    "frequencyShort": "M",
    "units": "Percent",
    "unitsShort": "%",
    "seasonalAdjustment": "Seasonally Adjusted",
    "seasonalAdjustmentShort": "SA",
    "lastUpdated": "2026-06-15 08:30:11-05",
    "popularity": "30",
    "notes": "explanatory notes issued by the Board of Governors."
  },
  {
    "id": "IPB53122S",
    "realtimeStart": "2026-07-10",
    "realtimeEnd": "2026-07-10",
    "title": "Industrial Production: Durable Goods Materials: Semiconductors, Printed Circuit Boards, and Other",
    "observationStart": "1954-01-01",
    "observationEnd": "2026-05-01",
    "frequency": "Monthly",
    "frequencyShort": "M",
    "units": "Index 2017=100",
    "unitsShort": "Index 2017=100",
    "seasonalAdjustment": "Seasonally Adjusted",
    "seasonalAdjustmentShort": "SA",
    "lastUpdated": "2026-06-15 08:31:01-05",
    "popularity": "17",
    "notes": "explanatory notes issued by the Board of Governors."
  }
]`,
  "04-macros-and-signals/economic-datasets/00-search": `[
  {
    "id": "PMAIZMTUSDM",
    "realtimeStart": "2025-12-25",
    "realtimeEnd": "2025-12-25",
    "title": "Global price of Corn",
    "observationStart": "1990-01-01",
    "observationEnd": "2025-06-01",
    "frequency": "Monthly",
    "frequencyShort": "M",
    "units": "U.S. Dollars per Metric Ton",
    "unitsShort": "U.S. $ per Metric Ton",
    "seasonalAdjustment": "Not Seasonally Adjusted",
    "seasonalAdjustmentShort": "NSA",
    "lastUpdated": "2025-07-18 09:37:11-05",
    "popularity": "54",
    "notes": "Value represents the benchmark prices which are representative of the global market. They are determined by the largest exporter of a given commodity. Prices are period averages in nominal U.S. dollars.\\n\\nCopyright © 2016, International Monetary Fund. Reprinted with permission. Complete terms of use and contact details are available at http://www.imf.org/external/terms.htm."
  },
  {
    "id": "PMAIZMTUSDA",
    "realtimeStart": "2025-12-25",
    "realtimeEnd": "2025-12-25",
    "title": "Global price of Corn",
    "observationStart": "1990-01-01",
    "observationEnd": "2024-01-01",
    "frequency": "Annual",
    "frequencyShort": "A",
    "units": "U.S. Dollars per Metric Ton",
    "unitsShort": "U.S. $ per Metric Ton",
    "seasonalAdjustment": "Not Seasonally Adjusted",
    "seasonalAdjustmentShort": "NSA",
    "lastUpdated": "2025-01-27 13:31:17-06",
    "popularity": "24",
    "notes": "Value represents the benchmark prices which are representative of the global market. They are determined by the largest exporter of a given commodity. Prices are period averages in nominal U.S. dollars.\\n\\nCopyright © 2016, International Monetary Fund. Reprinted with permission. Complete terms of use and contact details are available at http://www.imf.org/external/terms.htm."
  }
]`,
  "04-macros-and-signals/economic-datasets/data": `[
  {
    "realtimeStart": "2015-03-13T00:00:00.000Z",
    "date": "1971-01-01T00:00:00.000Z",
    "value": 63.4
  },
  {
    "realtimeStart": "2015-03-13T00:00:00.000Z",
    "date": "1971-02-01T00:00:00.000Z",
    "value": 63.6
  },
  {
    "realtimeStart": "2015-03-13T00:00:00.000Z",
    "date": "1971-03-01T00:00:00.000Z",
    "value": 62
  },
  {
    "realtimeStart": "2015-03-13T00:00:00.000Z",
    "date": "1971-04-01T00:00:00.000Z",
    "value": 60.8
  }
]`,
  "04-macros-and-signals/news/corporate": `[
  {
    "title": "Apple spent 2025 setting itself up for the future - and its biggest moves weren't about AI - Yahoo Finance",
    "link": "https://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWl6d0ZCVlY5NWNVeE5OblZDV1VwbVMxTnhaVlZRYVd4VlRqQk9XR1ZOTWxFM1UxaFdiRjlXYld4elNDMWlVVk5IYWxKT1pFbGhWbmc1TlZKRlEycHJNMHBKYjNGeGMyUXlPRTAzZGxGNFRGaFRiVUZWTUhveGRsRk9Va2M1YmxKV2R6RTFSbkV4VDBKV1pHTmtNMVJ6TVRsV00xaFZjbWRwYVRsUFJYbEdRbGRMU3pWMFVrZGZUVFJzZFdkWE9Vb3lUSGgyT0hZMlZWQTROM2R5YUhkb1pVczJiM0JLVVV0d2FuUk5RalpKTUZacVpITm9WamhXVEhOamVVaG9WMnhMZGt4dFUxWk1hV2szVlZaUlJ6bERhekE_b2M9NQ",
    "summary": "Apple spent 2025 setting itself up for the future - and its biggest moves weren't about AI  Yahoo Finance",
    "published": "Wed, 24 Dec 2025 09:05:43 GMT"
  },
  {
    "title": "Apple Just Released a New AI Model. Should You Buy AAPL Stock Here? - Barchart.com",
    "link": "https://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWlyd0ZCVlY5NWNVeE9aRVV6TkZoTWJqbFpiRzV2YTI4MlFsUnFjMGhxVldSbU0waFZWek5SU0d4WlRsRkdaRWg0YW05Rk9IcFBUbFE0WTNJMlNDMUxOMk5oYjJ4SGEzQktNMGhqUmpkd2NWOUVWelpWY3pCZmFWcHVhemhFVTA5RFpuSlBlbkJEV0hGV2FtNUxXV1ZaTW1GUE9GWkljSGxzU0hWNGFrZHFiVk41U2psQ2RFOXplRk52YmpVM1dXSTJTa3hWWVZZd1VsVmZTM1pCY21wR05ubHdTWEY2T1RneGIwbHBNVWhLYVZWSj9vYz01",
    "summary": "Apple Just Released a New AI Model. Should You Buy AAPL Stock Here?  Barchart.com",
    "published": "Tue, 23 Dec 2025 16:00:03 GMT"
  }
]`,
  "04-macros-and-signals/news/global": `[
  {
    "title": "Trump Live Updates: DOJ Says It Has Found 1 Million More Epstein Files - The New York Times",
    "link": "https://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWlZMEZWWDNseFRFOTFiMVIzWVhseE1YbE1TSGd3YW1sSFpFcFdiRmhTWjJWTWNYTmtlRmxQWkdGeGN6SlBXSFp3UzFwTExYTlViRGxYWlRKTFRUVjBiVmgwYlUxVWJtUjVla3BYVEhrd1dqaEdXV1l3YUVSSFVrcGxRVTU0YkdvMFFUVlNVUT9vYz01",
    "summary": "Trump Live Updates: DOJ Says It Has Found 1 Million More Epstein Files  The New York Times\\nNews Wrap: DOJ says over a million more Epstein documents discovered  PBS\\n'It's perpetuated this news cycle': Frustration mounts in Trump's orbit about messaging on latest Epstein documents  CNN\\nTakeaways from the 3rd Epstein files release: The president, the plane and the prince  NBC News\\nDOJ says more than 1 million potential Epstein files newly uncovered  CNBC",
    "published": "Wed, 24 Dec 2025 21:31:18 GMT"
  }
]`,
  "04-macros-and-signals/news/live-feed": `[
  {
    "title": "Trump Live Updates: DOJ Says It Has Found 1 Million More Epstein Files - The New York Times",
    "link": "https://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWlZMEZWWDNseFRFOTFiMVIzWVhseE1YbE1TSGd3YW1sSFpFcFdiRmhTWjJWTWNYTmtlRmxQWkdGeGN6SlBXSFp3UzFwTExYTlViRGxYWlRKTFRUVjBiVmgwYlUxVWJtUjVla3BYVEhrd1dqaEdXV1l3YUVSSFVrcGxRVTU0YkdvMFFUVlNVUT9vYz01",
    "summary": "Trump Live Updates: DOJ Says It Has Found 1 Million More Epstein Files  The New York Times\\nNews Wrap: DOJ says over a million more Epstein documents discovered  PBS\\n'It's perpetuated this news cycle': Frustration mounts in Trump's orbit about messaging on latest Epstein documents  CNN\\nTakeaways from the 3rd Epstein files release: The president, the plane and the prince  NBC News\\nDOJ says more than 1 million potential Epstein files newly uncovered  CNBC",
    "published": "Wed, 24 Dec 2025 21:31:18 GMT"
  },
  {
    "title": "Powerful winter storm arrives in Southern California for Christmas holiday. Here's what to know. - CBS News",
    "link": "https://api.axionquant.com/news/article/aHR0cHM6Ly9uZXdzLmdvb2dsZS5jb20vcnNzL2FydGljbGVzL0NCTWl0QUZCVlY5NWNVeE9RbUowTTNGdE5XUnNXVFV4U2pKa09VWmZja2h2YWtoTmVHaDJSWFZUZVVwRGVIRkRRV2RVYlc5M1NYZEhMVGxEVUZoa1IxbDZOek5ZUWtscU1WTllWRU5YWVRKcGRtdFlXR1ZaUmtkZmNuVldXRTF6VjJGQlVVcFlSbDgyUjNKMlJtMUVVbUpGTFhoalRqbGhTemhTYldrM1VuUnpVRFEyT0ZGd0xVeFVZMlJKY0hvd2QwSkdVM0JHVWs5cmNUbGlXaTEwUm5abFREQnRURkJtU1V0Nk5tNU9PRGwxV2xoeGRVaGhTVVU_b2M9NQ",
    "summary": "Powerful winter storm arrives in Southern California for Christmas holiday. Here's what to know.  CBS News\\nStorm brings heavy rain, wind; Flash Flood Warning extended for parts of LA and Ventura counties  ABC7 Los Angeles\\nFlooding Causes Road Closures and Vehicle Rescues Across Hesperia and Surrounding Areas  VVNG\\nIntense Storm in Southern California Brings Heavy Rain and Forces Evacuations  The New York Times\\nCalifornia weather: Flash flood warning in effect across SoCal as powerful storm arrives  FOX 11 Los Angeles",
    "published": "Wed, 24 Dec 2025 14:52:00 GMT"
  }
]`,
  "01-market-data/stocks/list-market": `[
  "america",
  "australia",
  "canada",
  "china",
  "germany",
  "hongkong",
  "india",
  "japan",
  "korea",
  "ksa",
  "mexico",
  "singapore",
  "uk"
]`,
  "01-market-data/stocks/list-country": `[
  "Aland Islands",
  "Anguilla",
  "Argentina",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belgium",
  "Bermuda",
  "Brazil",
  "British Virgin Islands",
  "Bulgaria",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands",
  "Chile",
  "China",
  "Colombia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Dominican Republic",
  "Egypt",
  "El Salvador",
  "Estonia",
  "Faroe Islands",
  "Finland",
  "France",
  "Gabon",
  "Germany",
  "Gibraltar",
  "Greece",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "La Reunion",
  "Liberia",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Malaysia",
  "Malta",
  "Mauritius",
  "Mexico",
  "Monaco",
  "Mongolia",
  "Morocco",
  "Mozambique",
  "Netherlands",
  "New Zealand",
  "Nigeria",
  "Norway",
  "Oman",
  "Pakistan",
  "Panama",
  "Papua New Guinea",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russian Federation",
  "Saudi Arabia",
  "Singapore",
  "Slovenia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Tanzania",
  "Thailand",
  "Turkey",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vietnam",
  "Zambia",
  "america",
  "australia",
  "canada",
  "china",
  "germany",
  "hongkong",
  "india",
  "japan",
  "korea",
  "ksa",
  "mexico",
  "singapore",
  "uk"
]`,
  "01-market-data/stocks/list-currency": `[
  "AUD",
  "CAD",
  "CHF",
  "CNY",
  "DKK",
  "EUR",
  "GBP",
  "GBX",
  "HKD",
  "HUF",
  "INR",
  "JPY",
  "KRW",
  "MXN",
  "NOK",
  "NZD",
  "PLN",
  "SAR",
  "SEK",
  "SGD",
  "USD"
]`,
  "01-market-data/stocks/list-sector": `[
  "Commercial Services",
  "Communications",
  "Consumer Durables",
  "Consumer Non-Durables",
  "Consumer Services",
  "Distribution Services",
  "Electronic Technology",
  "Energy Minerals",
  "Finance",
  "Government",
  "Health Services",
  "Health Technology",
  "Industrial Services",
  "Miscellaneous",
  "N/A",
  "Non-Energy Minerals",
  "Process Industries",
  "Producer Manufacturing",
  "Retail Trade",
  "Technology Services",
  "Transportation",
  "Utilities"
]`,
  "01-market-data/stocks/list-industry": `[
  "Advertising/Marketing Services",
  "Aerospace & Defense",
  "Agricultural Commodities/Milling",
  "Air Freight/Couriers",
  "Airlines",
  "Alternative Power Generation",
  "Aluminum",
  "Apparel/Footwear",
  "Apparel/Footwear Retail",
  "Auto Parts: OEM",
  "Automotive Aftermarket",
  "Beverages: Alcoholic",
  "Beverages: Non-Alcoholic",
  "Biotechnology",
  "Broadcasting",
  "Building Products",
  "Cable/Satellite TV",
  "Casinos/Gaming",
  "Catalog/Specialty Distribution",
  "Chemicals: Agricultural",
  "Chemicals: Major Diversified",
  "Chemicals: Specialty",
  "Coal",
  "Commercial Printing/Forms",
  "Computer Communications",
  "Computer Peripherals",
  "Computer Processing Hardware",
  "Construction Materials",
  "Consumer Sundries",
  "Containers/Packaging",
  "Contract Drilling",
  "Data Processing Services",
  "Department Stores",
  "Discount Stores",
  "Drugstore Chains",
  "Electric Utilities",
  "Electrical Products",
  "Electronic Components",
  "Electronic Equipment/Instruments",
  "Electronic Production Equipment",
  "Electronics Distributors",
  "Electronics/Appliance Stores",
  "Electronics/Appliances",
  "Engineering & Construction",
  "Environmental Services",
  "Finance/Rental/Leasing",
  "Financial Conglomerates",
  "Financial Publishing/Services",
  "Food Distributors",
  "Food Retail",
  "Food: Major Diversified",
  "Food: Meat/Fish/Dairy",
  "Food: Specialty/Candy",
  "Forest Products",
  "Gas Distributors",
  "General Government",
  "Home Furnishings",
  "Home Improvement Chains",
  "Homebuilding",
  "Hospital/Nursing Management",
  "Hotels/Resorts/Cruise lines",
  "Household/Personal Care",
  "Industrial Conglomerates",
  "Industrial Machinery",
  "Industrial Specialties",
  "Information Technology Services",
  "Insurance Brokers/Services",
  "Integrated Oil",
  "Internet Retail",
  "Internet Software/Services",
  "Investment Banks/Brokers",
  "Investment Managers",
  "Investment Trusts/Mutual Funds",
  "Life/Health Insurance",
  "Major Banks",
  "Major Telecommunications",
  "Managed Health Care",
  "Marine Shipping",
  "Media Conglomerates",
  "Medical Distributors",
  "Medical Specialties",
  "Medical/Nursing Services",
  "Metal Fabrication",
  "Miscellaneous",
  "Miscellaneous Commercial Services",
  "Miscellaneous Manufacturing",
  "Motor Vehicles",
  "Movies/Entertainment",
  "Multi-Line Insurance",
  "N/A",
  "Office Equipment/Supplies",
  "Oil & Gas Pipelines",
  "Oil & Gas Production",
  "Oil Refining/Marketing",
  "Oilfield Services/Equipment",
  "Other Consumer Services",
  "Other Consumer Specialties",
  "Other Metals/Minerals",
  "Other Transportation",
  "Packaged Software",
  "Personnel Services",
  "Pharmaceuticals: Generic",
  "Pharmaceuticals: Major",
  "Pharmaceuticals: Other",
  "Precious Metals",
  "Property/Casualty Insurance",
  "Publishing: Books/Magazines",
  "Publishing: Newspapers",
  "Pulp & Paper",
  "Railroads",
  "Real Estate Development",
  "Real Estate Investment Trusts",
  "Recreational Products",
  "Regional Banks",
  "Restaurants",
  "Savings Banks",
  "Semiconductors",
  "Services to the Health Industry",
  "Sovereign",
  "Specialty Insurance",
  "Specialty Stores",
  "Specialty Telecommunications",
  "Steel",
  "Telecommunications Equipment",
  "Textiles",
  "Tobacco",
  "Tools & Hardware",
  "Trucking",
  "Trucks/Construction/Farm Machinery",
  "Water Utilities",
  "Wholesale Distributors",
  "Wireless Telecommunications"
]`,
  "01-market-data/stocks/list-type": `[
  "closedend fund",
  "common stock",
  "dr",
  "etf fund",
  "mutual fund",
  "preferred stock",
  "reit fund",
  "structured",
  "unit fund"
]`,
  "01-market-data/stocks/list-exchange": `[
  "AMEX",
  "AQUIS",
  "ASX",
  "BIVA",
  "BMV",
  "BSE",
  "CBOE",
  "CSE",
  "DUS",
  "FSE",
  "FWB",
  "HAM",
  "HAN",
  "HKEX",
  "KRX",
  "LSE",
  "LSIN",
  "MUN",
  "NAG",
  "NASDAQ",
  "NEO",
  "NSE",
  "NYSE",
  "OTC",
  "SAPSE",
  "SGX",
  "SSE",
  "SWB",
  "SZSE",
  "TADAWUL",
  "TSE",
  "TSX",
  "TSXV",
  "XETR"
]`,
  "01-market-data/ETFs/list-market": `[
  "america",
  "australia",
  "canada",
  "china",
  "germany",
  "hongkong",
  "india",
  "japan",
  "korea",
  "ksa",
  "mexico",
  "singapore",
  "uk"
]`,
  "01-market-data/ETFs/list-country": `[
  "Aland Islands",
  "Anguilla",
  "Argentina",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belgium",
  "Bermuda",
  "Brazil",
  "British Virgin Islands",
  "Bulgaria",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands",
  "Chile",
  "China",
  "Colombia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Dominican Republic",
  "Egypt",
  "El Salvador",
  "Estonia",
  "Faroe Islands",
  "Finland",
  "France",
  "Gabon",
  "Germany",
  "Gibraltar",
  "Greece",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "La Reunion",
  "Liberia",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Malaysia",
  "Malta",
  "Mauritius",
  "Mexico",
  "Monaco",
  "Mongolia",
  "Morocco",
  "Mozambique",
  "Netherlands",
  "New Zealand",
  "Nigeria",
  "Norway",
  "Oman",
  "Pakistan",
  "Panama",
  "Papua New Guinea",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russian Federation",
  "Saudi Arabia",
  "Singapore",
  "Slovenia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Tanzania",
  "Thailand",
  "Turkey",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vietnam",
  "Zambia",
]`,
  "01-market-data/ETFs/list-currency": `[
  "AUD",
  "CAD",
  "CHF",
  "CNY",
  "DKK",
  "EUR",
  "GBP",
  "GBX",
  "HKD",
  "HUF",
  "INR",
  "JPY",
  "KRW",
  "MXN",
  "NOK",
  "NZD",
  "PLN",
  "SAR",
  "SEK",
  "SGD",
  "USD"
]`,
  "01-market-data/ETFs/list-sector": `[
  "Commercial Services",
  "Communications",
  "Consumer Durables",
  "Consumer Non-Durables",
  "Consumer Services",
  "Distribution Services",
  "Electronic Technology",
  "Energy Minerals",
  "Finance",
  "Government",
  "Health Services",
  "Health Technology",
  "Industrial Services",
  "Miscellaneous",
  "N/A",
  "Non-Energy Minerals",
  "Process Industries",
  "Producer Manufacturing",
  "Retail Trade",
  "Technology Services",
  "Transportation",
  "Utilities"
]`,
  "01-market-data/ETFs/list-industry": `[
  "Advertising/Marketing Services",
  "Aerospace & Defense",
  "Agricultural Commodities/Milling",
  "Air Freight/Couriers",
  "Airlines",
  "Alternative Power Generation",
  "Aluminum",
  "Apparel/Footwear",
  "Apparel/Footwear Retail",
  "Auto Parts: OEM",
  "Automotive Aftermarket",
  "Beverages: Alcoholic",
  "Beverages: Non-Alcoholic",
  "Biotechnology",
  "Broadcasting",
  "Building Products",
  "Cable/Satellite TV",
  "Casinos/Gaming",
  "Catalog/Specialty Distribution",
  "Chemicals: Agricultural",
  "Chemicals: Major Diversified",
  "Chemicals: Specialty",
  "Coal",
  "Commercial Printing/Forms",
  "Computer Communications",
  "Computer Peripherals",
  "Computer Processing Hardware",
  "Construction Materials",
  "Consumer Sundries",
  "Containers/Packaging",
  "Contract Drilling",
  "Data Processing Services",
  "Department Stores",
  "Discount Stores",
  "Drugstore Chains",
  "Electric Utilities",
  "Electrical Products",
  "Electronic Components",
  "Electronic Equipment/Instruments",
  "Electronic Production Equipment",
  "Electronics Distributors",
  "Electronics/Appliance Stores",
  "Electronics/Appliances",
  "Engineering & Construction",
  "Environmental Services",
  "Finance/Rental/Leasing",
  "Financial Conglomerates",
  "Financial Publishing/Services",
  "Food Distributors",
  "Food Retail",
  "Food: Major Diversified",
  "Food: Meat/Fish/Dairy",
  "Food: Specialty/Candy",
  "Forest Products",
  "Gas Distributors",
  "General Government",
  "Home Furnishings",
  "Home Improvement Chains",
  "Homebuilding",
  "Hospital/Nursing Management",
  "Hotels/Resorts/Cruise lines",
  "Household/Personal Care",
  "Industrial Conglomerates",
  "Industrial Machinery",
  "Industrial Specialties",
  "Information Technology Services",
  "Insurance Brokers/Services",
  "Integrated Oil",
  "Internet Retail",
  "Internet Software/Services",
  "Investment Banks/Brokers",
  "Investment Managers",
  "Investment Trusts/Mutual Funds",
  "Life/Health Insurance",
  "Major Banks",
  "Major Telecommunications",
  "Managed Health Care",
  "Marine Shipping",
  "Media Conglomerates",
  "Medical Distributors",
  "Medical Specialties",
  "Medical/Nursing Services",
  "Metal Fabrication",
  "Miscellaneous",
  "Miscellaneous Commercial Services",
  "Miscellaneous Manufacturing",
  "Motor Vehicles",
  "Movies/Entertainment",
  "Multi-Line Insurance",
  "N/A",
  "Office Equipment/Supplies",
  "Oil & Gas Pipelines",
  "Oil & Gas Production",
  "Oil Refining/Marketing",
  "Oilfield Services/Equipment",
  "Other Consumer Services",
  "Other Consumer Specialties",
  "Other Metals/Minerals",
  "Other Transportation",
  "Packaged Software",
  "Personnel Services",
  "Pharmaceuticals: Generic",
  "Pharmaceuticals: Major",
  "Pharmaceuticals: Other",
  "Precious Metals",
  "Property/Casualty Insurance",
  "Publishing: Books/Magazines",
  "Publishing: Newspapers",
  "Pulp & Paper",
  "Railroads",
  "Real Estate Development",
  "Real Estate Investment Trusts",
  "Recreational Products",
  "Regional Banks",
  "Restaurants",
  "Savings Banks",
  "Semiconductors",
  "Services to the Health Industry",
  "Sovereign",
  "Specialty Insurance",
  "Specialty Stores",
  "Specialty Telecommunications",
  "Steel",
  "Telecommunications Equipment",
  "Textiles",
  "Tobacco",
  "Tools & Hardware",
  "Trucking",
  "Trucks/Construction/Farm Machinery",
  "Water Utilities",
  "Wholesale Distributors",
  "Wireless Telecommunications"
]`,
  "01-market-data/ETFs/list-type": `[
  "closedend fund",
  "common stock",
  "dr",
  "etf fund",
  "mutual fund",
  "preferred stock",
  "reit fund",
  "structured",
  "unit fund"
]`,
  "01-market-data/ETFs/list-exchange": `[
  "AMEX",
  "AQUIS",
  "ASX",
  "BIVA",
  "BMV",
  "BSE",
  "CBOE",
  "CSE",
  "DUS",
  "FSE",
  "FWB",
  "HAM",
  "HAN",
  "HKEX",
  "KRX",
  "LSE",
  "LSIN",
  "MUN",
  "NAG",
  "NASDAQ",
  "NEO",
  "NSE",
  "NYSE",
  "OTC",
  "SAPSE",
  "SGX",
  "SSE",
  "SWB",
  "SZSE",
  "TADAWUL",
  "TSE",
  "TSX",
  "TSXV",
  "XETR"
]`,
  "01-market-data/indices/list-exchange": `[
  "AMS",
  "ASE",
  "ASX",
  "BRU",
  "BSE",
  "BUD",
  "BUE",
  "BVB",
  "BVC",
  "CAI",
  "CGI",
  "CXI",
  "DJI",
  "DOH",
  "EBS",
  "FGI",
  "FSI",
  "GER",
  "HKG",
  "ISE",
  "IST",
  "JKT",
  "JNB",
  "KLS",
  "KOE",
  "KSC",
  "LIS",
  "MCE",
  "MEX",
  "MSC",
  "NIM",
  "NSI",
  "NYS",
  "NZE",
  "OPI",
  "OSA",
  "PAR",
  "PRA",
  "SAO",
  "SAU",
  "SES",
  "SET",
  "SGO",
  "SNP",
  "STO",
  "STU",
  "TAI",
  "TLV",
  "TSI",
  "VIE",
  "VSE",
  "WCB",
  "YHD",
  "ZRH"
]`,
  "01-market-data/indices/list-timezone": `[
  "AEST",
  "ART",
  "AST",
  "BRT",
  "BST",
  "CDT",
  "CEST",
  "CLT",
  "CST",
  "EDT",
  "EEST",
  "HKT",
  "ICT",
  "IDT",
  "IST",
  "JST",
  "KST",
  "MYT",
  "NZST",
  "SAST",
  "SGT",
  "TRT",
  "WEST",
  "WIB"
]`,
  "01-market-data/indices/list-country": `[
  "africa",
  "america",
  "asia",
  "australia",
  "europe",
  "pacific"
]`,
  "01-market-data/futures/list-exchange": `[
  "CBT",
  "CME",
  "CMX",
  "NYB",
  "NYM",
  "SES"
]`,
  "01-market-data/futures/list-currency": `[
  "CAD",
  "CHF",
  "EUR",
  "GBP",
  "JPY",
  "NOK",
  "SEK",
  "USD",
  "USX"
]`,
  "01-market-data/futures/list-timezone": `[
  "EDT",
  "SGT"
]`,
  "01-market-data/futures/list-country": `[
  "america",
  "asia"
]`,
  "01-market-data/forex/list-exchange": `[
  "IDC"
]`,
  "01-market-data/forex/list-rating": `[
  "buy",
  "neutral",
  "sell",
  "strongbuy",
  "strongsell"
]`,
  "01-market-data/forex/list-country": `[
  "AE",
  "AF",
  "AG",
  "AL",
  "AM",
  "AO",
  "AR",
  "AU",
  "AW",
  "BA",
  "BB",
  "BD",
  "BH",
  "BI",
  "BJ",
  "BM",
  "BN",
  "BO",
  "BR",
  "BS",
  "BT",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CD",
  "CF",
  "CH",
  "CL",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CZ",
  "DJ",
  "DK",
  "DO",
  "DZ",
  "EG",
  "ER",
  "ET",
  "EU",
  "FJ",
  "FK",
  "GB",
  "GE",
  "GH",
  "GI",
  "GM",
  "GN",
  "GT",
  "GY",
  "HK",
  "HN",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IN",
  "IQ",
  "IR",
  "IS",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KM",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LK",
  "LR",
  "LS",
  "LY",
  "MA",
  "MD",
  "MG",
  "MK",
  "MM",
  "MN",
  "MO",
  "MR",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NG",
  "NI",
  "NO",
  "NP",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PY",
  "QA",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SL",
  "SO",
  "SR",
  "ST",
  "SV",
  "SY",
  "SZ",
  "TH",
  "TJ",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TW",
  "TZ",
  "UA",
  "UG",
  "US",
  "UY",
  "UZ",
  "VE",
  "VN",
  "VU",
  "WS",
  "YE",
  "ZA",
  "ZM",
  "crypto/XTVCOU",
  "metal/silver"
]`,
  "01-market-data/crypto/list-category": `[
  "algorithmic stablecoins",
  "analytics",
  "asset management",
  "asset-backed tokens",
  "centralized exchange",
  "cryptocurrencies",
  "dao",
  "data management and ai",
  "decentralized exchange",
  "defi",
  "depin",
  "derivatives",
  "developments tools",
  "distributed computing and storage",
  "e-commerce",
  "education",
  "energy",
  "enterprise solutions",
  "fan tokens",
  "fundraising",
  "gambling",
  "gaming",
  "health",
  "identity",
  "insurance",
  "internet of things",
  "interoperability",
  "iso 20022",
  "jobs",
  "layer 1",
  "lending and borrowing",
  "loyalty and rewards",
  "made in america",
  "made in china",
  "marketing",
  "marketplace",
  "memes",
  "move to earn",
  "nfts and collectibles",
  "oracles",
  "payments",
  "prediction markets",
  "privacy",
  "real estate",
  "real-world assets",
  "rehypothecated assets",
  "scaling",
  "smart contract platforms",
  "social media and content",
  "sports",
  "stablecoins",
  "transport",
  "web3",
  "wrapped tokens"
]`,
  "01-market-data/crypto/list-rating": `[
  "buy",
  "neutral",
  "sell",
  "strongbuy",
  "strongsell"
]`,
  "01-market-data/crypto/list-type": `[
  "spot"
]`,
  "03-fundamentals/financials/statement-balance": `{
  "accountsPayable": 14696000000,
  "accountsReceivable": 3959000000,
  "accumulatedDepreciation": -21351000000,
  "additionalPaidInCapital": 44299000000,
  "capitalLeaseObligations": 6871000000,
  "capitalStock": 3000000,
  "cash": 14470000000,
  "cashAndCashEquivalents": 16603000000,
  "cashCashEquivalentsAndShortTermInvestments": 44743000000,
  "cashEquivalents": 2133000000,
  "commonStock": 3000000,
  "commonStockEquity": 84116000000,
  "constructionInProgress": 9629000000,
  "currentAccruedExpenses": 5065000000,
  "currentAssets": 69748000000,
  "currentCapitalLeaseObligation": 1061000000,
  "currentDebt": 1374000000,
  "currentDebtAndCapitalLeaseObligation": 2435000000,
  "currentDeferredLiabilities": 5183000000,
  "currentDeferredRevenue": 5183000000,
  "currentLiabilities": 34138000000,
  "currentProvisions": 3015000000,
  "finishedGoods": 6842000000,
  "gainsLossesNotAffectingRetainedEarnings": 334000000,
  "goodwill": null,
  "goodwillAndOtherIntangibleAssets": 786000000,
  "grossPpe": 79991000000,
  "inventory": 14434000000,
  "investedCapital": 93135000000,
  "investmentsAndAdvances": null,
  "landAndImprovements": 12558000000,
  "leases": 4608000000,
  "lineOfCredit": null,
  "longTermCapitalLeaseObligation": 5810000000,
  "longTermDebt": 7645000000,
  "longTermDebtAndCapitalLeaseObligation": 13455000000,
  "longTermProvisions": 6028000000,
  "machineryFurnitureEquipment": 29685000000,
  "minorityInterest": 686000000,
  "netPpe": 58640000000,
  "netTangibleAssets": 83330000000,
  "nonCurrentDeferredAssets": 7060000000,
  "nonCurrentDeferredLiabilities": 3847000000,
  "nonCurrentDeferredRevenue": 3847000000,
  "nonCurrentDeferredTaxesAssets": 7060000000,
  "ordinarySharesNumber": 3755000000,
  "otherCurrentAssets": 6612000000,
  "otherCurrentBorrowings": 1374000000,
  "otherCurrentLiabilities": 2131000000,
  "otherEquityAdjustments": 334000000,
  "otherIntangibleAssets": 786000000,
  "otherInventories": 1360000000,
  "otherInvestments": null,
  "otherNonCurrentAssets": 7490000000,
  "otherNonCurrentLiabilities": 1454000000,
  "otherProperties": 23511000000,
  "otherShortTermInvestments": 28140000000,
  "payables": 16309000000,
  "payablesAndAccruedExpenses": 21374000000,
  "preferredStock": null,
  "properties": null,
  "rawMaterials": 4310000000,
  "receivables": 3959000000,
  "retainedEarnings": 39480000000,
  "shareIssued": 3755000000,
  "stockholdersEquity": 84116000000,
  "tangibleBookValue": 83330000000,
  "totalAssets": 143724000000,
  "totalCapitalization": 91761000000,
  "totalDebt": 15890000000,
  "totalEquityGrossMinorityInterest": 84802000000,
  "totalLiabilitiesNetMinorityInterest": 58922000000,
  "totalNonCurrentAssets": 73976000000,
  "totalNonCurrentLiabilitiesNetMinorityInterest": 24784000000,
  "totalTaxPayable": 1613000000,
  "treasurySharesNumber": null,
  "workInProcess": 1922000000,
  "workingCapital": 35610000000
}`,
  "03-fundamentals/financials/statement-income": `{
  "averageDilutionEarnings": null,
  "basicAverageShares": 3229000000,
  "basicEps": 1.2,
  "costOfRevenue": 79218000000,
  "dilutedAverageShares": 3532250000,
  "dilutedEps": 1.09,
  "dilutedNiAvailtoComStockholders": 3862000000,
  "ebit": 5776000000,
  "ebitda": 12067000000,
  "grossProfit": 18661000000,
  "interestExpense": 339000000,
  "interestExpenseNonOperating": 339000000,
  "interestIncome": 1714000000,
  "interestIncomeNonOperating": 1714000000,
  "minorityInterests": -64000000,
  "netIncome": 3862000000,
  "netIncomeCommonStockholders": 3862000000,
  "netIncomeContinuousOperations": 3926000000,
  "netIncomeFromContinuingAndDiscontinuedOperation": 3862000000,
  "netIncomeFromContinuingOperationNetMinorityInterest": 3862000000,
  "netIncomeIncludingNoncontrollingInterests": 3926000000,
  "netInterestIncome": 1375000000,
  "netNonOperatingInterestIncomeExpense": 1375000000,
  "normalizedEbitda": 12467000000,
  "normalizedIncome": 4150835755.01,
  "operatingExpense": 13364000000,
  "operatingIncome": 5297000000,
  "operatingRevenue": 97879000000,
  "otherIncomeExpense": -1235000000,
  "otherNonOperatingIncomeExpenses": -835000000,
  "otherunderPreferredStockDividend": null,
  "pretaxIncome": 5437000000,
  "reconciledCostOfRevenue": 79218000000,
  "reconciledDepreciation": 6291000000,
  "rentExpenseSupplemental": 956000000,
  "researchAndDevelopment": 6948000000,
  "restructuringAndMergernAcquisition": 400000000,
  "sellingGenAdmin": 6416000000,
  "specialIncomeCharges": -400000000,
  "taxEffectOfUnusualItems": -111164244.99,
  "taxProvision": 1511000000,
  "taxRateForCalcs": 0.28,
  "totalExpenses": 92582000000,
  "totalOperatingIncomeAsReported": 4897000000,
  "totalRevenue": 97879000000,
  "totalUnusualItems": -400000000,
  "totalUnusualItemsExcludingGoodwill": -400000000
}`,
  "03-fundamentals/financials/statement-cashflow": `{
  "assetImpairmentCharge": 327000000,
  "beginningCashPosition": 17250000000,
  "capitalExpenditure": -9528000000,
  "capitalExpenditureReported": null,
  "cashFlowFromContinuingFinancingActivities": 2643000000,
  "cashFlowFromContinuingInvestingActivities": -18850000000,
  "cashFlowFromContinuingOperatingActivities": 16528000000,
  "changeInAccountPayable": 4376000000,
  "changeInInventory": -1181000000,
  "changeInOtherCurrentAssets": 225000000,
  "changeInOtherCurrentLiabilities": null,
  "changeInOtherWorkingCapital": 317000000,
  "changeInPayable": 4376000000,
  "changeInPayablesAndAccruedExpense": 5071000000,
  "changeInPrepaidAssets": -2531000000,
  "changeInReceivables": -330000000,
  "changeInWorkingCapital": 1571000000,
  "changesInAccountReceivables": -330000000,
  "changesInCash": 321000000,
  "commonStockIssuance": null,
  "deferredIncomeTax": 30000000,
  "deferredTax": 30000000,
  "depreciation": 6291000000,
  "depreciationAmortizationDepletion": 6291000000,
  "depreciationAndAmortization": 6291000000,
  "effectOfExchangeRateChanges": 84000000,
  "endCashPosition": 17571000000,
  "financingCashFlow": 2643000000,
  "freeCashFlow": 7000000000,
  "gainLossOnSaleOfPpe": 165000000,
  "incomeTaxPaidSupplementalData": 1331000000,
  "interestPaidSupplementalData": 292000000,
  "investingCashFlow": -18850000000,
  "issuanceOfCapitalStock": null,
  "issuanceOfDebt": 9292000000,
  "longTermDebtIssuance": 9292000000,
  "longTermDebtPayments": -7849000000,
  "netBusinessPurchaseAndSale": null,
  "netCommonStockIssuance": null,
  "netForeignCurrencyExchangeGainLoss": 709000000,
  "netIncomeFromContinuingOperations": 3926000000,
  "netIntangiblesPurchaseAndSale": null,
  "netInvestmentPurchaseAndSale": -9322000000,
  "netIssuancePaymentsOfDebt": 1443000000,
  "netLongTermDebtIssuance": 1443000000,
  "netOtherFinancingCharges": -34000000,
  "netOtherInvestingChanges": null,
  "netPpePurchaseAndSale": -9528000000,
  "operatingCashFlow": 16528000000,
  "operatingGainsLosses": 874000000,
  "otherNonCashItems": 227000000,
  "proceedsFromStockOptionExercised": 1234000000,
  "purchaseOfBusiness": null,
  "purchaseOfIntangibles": null,
  "purchaseOfInvestment": -41414000000,
  "purchaseOfPpe": -9528000000,
  "repaymentOfDebt": -7849000000,
  "saleOfBusiness": null,
  "saleOfIntangibles": null,
  "saleOfInvestment": 32092000000,
  "saleOfPpe": null,
  "stockBasedCompensation": 3282000000
}`,
};
